import * as pc from 'playcanvas';

const isMobile = typeof window !== 'undefined' ? window.innerWidth <= 440 : false;

const getQueryParam = (param) => {
    if (typeof window === 'undefined') return null;
    const urlParams = new URLSearchParams(window.location.search);
    return urlParams.get(param);
};
export const defaultValue = {
    gallery: {
        localPosition: {
            x: 0,
            y: 0,
            z: 0
        },
        localScale: {
            x: 1,
            y: 1,
            z: 1
        },
        eulerAngles: {
            x: 0,
            y: 0,
            z: 0
        }
    },
    camera: {
        localPosition: {
            x: 0,
            y: 0,
            z: 0
        },
        localScale: {
            x: 1,
            y: 1,
            z: 1
        },
        eulerAngles: {
            x: 0,
            y: 0,
            z: 0
        },
        cameraConfig: {
            clearColor: new pc.Color(0.2, 0.2, 0.2),
            resolution: isMobile ? 0.5 : 1,
            farClip: isMobile ? 300 : 1000,
            fov: isMobile && window.innerHeight > window.innerWidth ? 60 : 45,
            nearClip: isMobile ? 0.3 : 0.1,
            toneMapping: pc.TONEMAP_NEUTRAL
        },
        cameraMotionConfig: {
            mobile: {
              initialPositionZOffset: 10,
            },
            desktop: {
             
            },
            common: {
              inertiaFactor: isMobile? 0.08 : 0.2,
              zoomSensitivity: isMobile ? 0.015 : 0.025, // Reduced for smoother zoom
              zoomInertiaFactor: 0.08,
              orbitSensitivity: isMobile? 0.15 : 0.2,
              zoomStepSize: 0.1,
              verticalRotationMin: 3,
              verticalRotationMax: 7,
              initialOrbitAngleX: -70,
            },
            fullControl: {
              initialPositionZOffset: 10,
              minDistance: 0,
              maxDistance: 500,
              verticalRotationMin: -90,
              verticalRotationMax: 90
            }
        }
    },
    car: {
        localScale: {
            x: 1,
            y: 1,
            z: 1
        },
        eulerAngles: {
            x: 0,
            y: 0,
            z: 0
        },
        localPosition: {
            x: 0,
            y: 0,
            z: 0
        }
    },
    shadow_caster: {
        localScale: {
            x: 1,
            y: 1,
            z: 1
        },
        eulerAngles: {
            x: 0,
            y: 0,
            z: 0
        },
        localPosition: {
            x: 0,
            y: 0,
            z: 0
        }
    },
    light: {
        directional: {
            localPosition: {
                x: 0,
                y: 0,
                z: 0
            },
            eulerAngles: {
                //55,90,20 - final
                //initial - 5.71, 32.09, 10.98
                x: 45,
                y: 45,
                z: 0
            },
            directionalConfig: {
                type: 'directional',
                color: pc.Color.WHITE,
                castShadows: true,
                intensity: 0.5,
                shadowBias: 0.2,
                normalOffsetBias: 0.05,
                shadowDistance: 30,
                shadowIntensity: 0.5,
                shadowResolution: 512,
                shadowType: pc.SHADOW_PCSS_32F,
                penumbraSize: 20,
                penumbraFalloff: 4,
                shadowSamples: 16,
                shadowBlockerSamples: 16
            }
        },
        point: {
            localPosition: {
                x: 0,
                y: 8,
                z: 0
            },
            eulerAngles: {
                x: 0,
                y: 0,
                z: 0
            },
            pointConfig: {
                type: 'point',
                color: new pc.Color(1, 1, 1),
                intensity: 2,
                range: 100,
                enabled: false
            }
        },
        ambient: {
            ambientConfig: {
                enabled: true
            }
        }
    }
}
export const headerAssets = {
  spyneLogo: "https://spyne-static.s3.amazonaws.com/console/spyneLogoPng.svg",
  headerLogo:
    "https://spyne-static.s3.amazonaws.com/console/console_header/console-logo.svg",
  redirectIcon: 'https://spyne-static.s3.amazonaws.com/console/accounts/redirect.svg',
};
export const iframeConfig = {
  status: {
       "yet_to_start": "Yet to start",
       "in_progress": "In progress",
       "completed": "Completed",
       "failed": "Failed",
       "to_serve": "To serve"
  },
  source: {
    "api": "API",
    "ios": "IOS"
  }
};
export const statusOptions =[
  {
    key: 'all',
    value: 'all',
    text: (
    <div>All</div>
    )
  },
  {
    key: 'completed',
    value: 'completed',
    text: (
      <div>Done</div>
    )
  },
  {
    key: 'yet_to_start',
    value: 'yet_to_start',
    text: (
      <div>Yet to start</div>
    )
  },
  {
    key: 'in_progress',
    value: 'in_progress',
    text: (
      <div>In progress</div>
    )
  },
  {
    key: 'failed',
    value: 'failed',
    text: (
      <div>Failed</div>
    ) 
  },
  {
    key: 'to_serve',
    value: 'to_serve',
    text: (
      <div>To serve</div>
    )
  }
]
export const demoVinDetails = {
    "imageUrls": [
        {
            "ai_angle": 40,
            "frame_seq_no": "1",
            "imageCategory": "Exterior",
            "image_id": "img-93f7e38f5591493397cfce9ca1190800",
            "inputUrl": "https://spyne-prod-tech.s3.amazonaws.com/TaD1VC1Ko/eaabbf28/b0c88eea2f0e4afb8749155bd87977ef/2b6a21f3cd604158b6fc37f5f4e7ece9/images/input/hres_5n1dl1gs2nc335977_2b6a21f3cd604158b6fc37f5f4e7ece9_Unclassified_8_2b6a21f3cd604158b6fc37f5f4e7ece9_Unclassified_8.jpg",
            "outputUrl": "https://spyne-media.s3.amazonaws.com/2024-10-22/car_replace_bg_36d8e4b7-6d34-48dd-81c9-a2520017bd22.jpg"
        },
        {
            "ai_angle": 30,
            "frame_seq_no": "19",
            "imageCategory": "360_exterior",
            "image_id": "img-ffda92809c3c4c3aad109d35eb51c8f2",
            "inputUrl": "https://spyne-prod-tech.s3.amazonaws.com/TaD1VC1Ko/eaabbf28/b0c88eea2f0e4afb8749155bd87977ef/2b6a21f3cd604158b6fc37f5f4e7ece9/images/input/hres_5n1dl1gs2nc335977_2b6a21f3cd604158b6fc37f5f4e7ece9_360_exterior_19_2b6a21f3cd604158b6fc37f5f4e7ece9_360_exterior_19.jpg",
            "outputUrl": "https://spyne-media.s3.amazonaws.com/2024-10-22/car_replace_bg_bf4cbd64-bc76-44db-be17-101c36671197.jpg"
        },
        {
            "ai_angle": 30,
            "frame_seq_no": "20",
            "imageCategory": "360_exterior",
            "image_id": "img-809687e1cf894a3f8561a5c614ba60dd",
            "inputUrl": "https://spyne-prod-tech.s3.amazonaws.com/TaD1VC1Ko/eaabbf28/b0c88eea2f0e4afb8749155bd87977ef/2b6a21f3cd604158b6fc37f5f4e7ece9/images/input/hres_5n1dl1gs2nc335977_2b6a21f3cd604158b6fc37f5f4e7ece9_360_exterior_20_2b6a21f3cd604158b6fc37f5f4e7ece9_360_exterior_20.jpg",
            "outputUrl": "https://spyne-media.s3.amazonaws.com/2024-10-22/car_replace_bg_908e2061-3e19-4166-ba39-2ead17c97ec4.jpg"
        },
        {
            "ai_angle": 30,
            "frame_seq_no": "21",
            "imageCategory": "360_exterior",
            "image_id": "img-e5bf32aa68be41ff81b27b1fa169e494",
            "inputUrl": "https://spyne-prod-tech.s3.amazonaws.com/TaD1VC1Ko/eaabbf28/b0c88eea2f0e4afb8749155bd87977ef/2b6a21f3cd604158b6fc37f5f4e7ece9/images/input/hres_5n1dl1gs2nc335977_2b6a21f3cd604158b6fc37f5f4e7ece9_360_exterior_21_2b6a21f3cd604158b6fc37f5f4e7ece9_360_exterior_21.jpg",
            "outputUrl": "https://spyne-media.s3.amazonaws.com/2024-10-22/car_replace_bg_cfab4c10-5b54-42fa-99d0-366566d483f3.jpg"
        },
        {
            "ai_angle": 40,
            "frame_seq_no": "22",
            "imageCategory": "360_exterior",
            "image_id": "img-888701a8ec314c36b3eff02ac5a1dad4",
            "inputUrl": "https://spyne-prod-tech.s3.amazonaws.com/TaD1VC1Ko/eaabbf28/b0c88eea2f0e4afb8749155bd87977ef/2b6a21f3cd604158b6fc37f5f4e7ece9/images/input/hres_5n1dl1gs2nc335977_2b6a21f3cd604158b6fc37f5f4e7ece9_360_exterior_22_2b6a21f3cd604158b6fc37f5f4e7ece9_360_exterior_22.jpg",
            "outputUrl": "https://spyne-media.s3.amazonaws.com/2024-10-22/car_replace_bg_457bf5de-360c-4d44-960d-8101bc8c446c.jpg"
        },
        {
            "ai_angle": 40,
            "frame_seq_no": "23",
            "imageCategory": "360_exterior",
            "image_id": "img-9559a0c63e694ecabbc920c793d0ac51",
            "inputUrl": "https://spyne-prod-tech.s3.amazonaws.com/TaD1VC1Ko/eaabbf28/b0c88eea2f0e4afb8749155bd87977ef/2b6a21f3cd604158b6fc37f5f4e7ece9/images/input/hres_5n1dl1gs2nc335977_2b6a21f3cd604158b6fc37f5f4e7ece9_360_exterior_23_2b6a21f3cd604158b6fc37f5f4e7ece9_360_exterior_23.jpg",
            "outputUrl": "https://spyne-media.s3.amazonaws.com/2024-10-22/car_replace_bg_79660055-e94a-467a-93bf-6c2bd144c68f.jpg"
        },
        {
            "ai_angle": 50,
            "frame_seq_no": "24",
            "imageCategory": "360_exterior",
            "image_id": "img-058884fe2c6c4cbc97810778aa54970b",
            "inputUrl": "https://spyne-prod-tech.s3.amazonaws.com/TaD1VC1Ko/eaabbf28/b0c88eea2f0e4afb8749155bd87977ef/2b6a21f3cd604158b6fc37f5f4e7ece9/images/input/hres_5n1dl1gs2nc335977_2b6a21f3cd604158b6fc37f5f4e7ece9_360_exterior_24_2b6a21f3cd604158b6fc37f5f4e7ece9_360_exterior_24.jpg",
            "outputUrl": "https://spyne-media.s3.amazonaws.com/2024-10-22/car_replace_bg_667b616d-2e0c-4aef-a396-cd1d73edbce5.jpg"
        },
        {
            "ai_angle": 50,
            "frame_seq_no": "25",
            "imageCategory": "360_exterior",
            "image_id": "img-48e42a263fac48eb95d14981d61a2322",
            "inputUrl": "https://spyne-prod-tech.s3.amazonaws.com/TaD1VC1Ko/eaabbf28/b0c88eea2f0e4afb8749155bd87977ef/2b6a21f3cd604158b6fc37f5f4e7ece9/images/input/hres_5n1dl1gs2nc335977_2b6a21f3cd604158b6fc37f5f4e7ece9_360_exterior_25_2b6a21f3cd604158b6fc37f5f4e7ece9_360_exterior_25.jpg",
            "outputUrl": "https://spyne-media.s3.amazonaws.com/2024-10-22/car_replace_bg_a43d82ad-56c8-4e14-b257-230a9d985db7.jpg"
        },
        {
            "ai_angle": 310,
            "frame_seq_no": "1",
            "imageCategory": "360_exterior",
            "image_id": "img-9f056afce8224915aed1634500a28bf4",
            "inputUrl": "https://spyne-prod-tech.s3.amazonaws.com/TaD1VC1Ko/eaabbf28/b0c88eea2f0e4afb8749155bd87977ef/2b6a21f3cd604158b6fc37f5f4e7ece9/images/input/hres_5n1dl1gs2nc335977_2b6a21f3cd604158b6fc37f5f4e7ece9_360_exterior_1_2b6a21f3cd604158b6fc37f5f4e7ece9_360_exterior_1.jpg",
            "outputUrl": "https://spyne-media.s3.amazonaws.com/2024-10-22/car_replace_bg_d6dd3663-bd29-428e-b622-87b2cadc2829.jpg"
        },
        {
            "ai_angle": 320,
            "frame_seq_no": "2",
            "imageCategory": "360_exterior",
            "image_id": "img-83ebbd552de447ad8a8523a3812b52dd",
            "inputUrl": "https://spyne-prod-tech.s3.amazonaws.com/TaD1VC1Ko/eaabbf28/b0c88eea2f0e4afb8749155bd87977ef/2b6a21f3cd604158b6fc37f5f4e7ece9/images/input/hres_5n1dl1gs2nc335977_2b6a21f3cd604158b6fc37f5f4e7ece9_360_exterior_2_2b6a21f3cd604158b6fc37f5f4e7ece9_360_exterior_2.jpg",
            "outputUrl": "https://spyne-media.s3.amazonaws.com/2024-10-22/car_replace_bg_9468cd7a-cae7-4542-a8ea-74beb5ff65d7.jpg"
        },
        {
            "ai_angle": 0,
            "frame_seq_no": "2",
            "imageCategory": "Exterior",
            "image_id": "img-64ac301275c94d7c99258d82fb54e85e",
            "inputUrl": "https://spyne-prod-tech.s3.amazonaws.com/TaD1VC1Ko/eaabbf28/b0c88eea2f0e4afb8749155bd87977ef/2b6a21f3cd604158b6fc37f5f4e7ece9/images/input/hres_5n1dl1gs2nc335977_2b6a21f3cd604158b6fc37f5f4e7ece9_Unclassified_9_2b6a21f3cd604158b6fc37f5f4e7ece9_Unclassified_9.jpg",
            "outputUrl": "https://spyne-media.s3.amazonaws.com/2024-10-22/car_replace_bg_1064bd83-562f-42ce-82cf-5256cc26bb2b.jpg"
        },
        {
            "ai_angle": 320,
            "frame_seq_no": "3",
            "imageCategory": "360_exterior",
            "image_id": "img-39df0a137a2f42d683145dd19712d15b",
            "inputUrl": "https://spyne-prod-tech.s3.amazonaws.com/TaD1VC1Ko/eaabbf28/b0c88eea2f0e4afb8749155bd87977ef/2b6a21f3cd604158b6fc37f5f4e7ece9/images/input/hres_5n1dl1gs2nc335977_2b6a21f3cd604158b6fc37f5f4e7ece9_360_exterior_3_2b6a21f3cd604158b6fc37f5f4e7ece9_360_exterior_3.jpg",
            "outputUrl": "https://spyne-media.s3.amazonaws.com/2024-10-22/car_replace_bg_fe148228-2f4a-4265-aa26-76738e038d8a.jpg"
        },
        {
            "ai_angle": 310,
            "frame_seq_no": "3",
            "imageCategory": "Exterior",
            "image_id": "img-9c064e718a1e40839d396aaa31d5c172",
            "inputUrl": "https://spyne-prod-tech.s3.amazonaws.com/TaD1VC1Ko/eaabbf28/b0c88eea2f0e4afb8749155bd87977ef/2b6a21f3cd604158b6fc37f5f4e7ece9/images/input/hres_5n1dl1gs2nc335977_2b6a21f3cd604158b6fc37f5f4e7ece9_Unclassified_2_2b6a21f3cd604158b6fc37f5f4e7ece9_Unclassified_2.jpg",
            "outputUrl": "https://spyne-media.s3.amazonaws.com/2024-10-22/car_replace_bg_4d015e54-7b84-4a12-a12e-04d8a577d908.jpg"
        },
        {
            "ai_angle": 330,
            "frame_seq_no": "4",
            "imageCategory": "360_exterior",
            "image_id": "img-d42709b7c415486e8f63a7b107396a1b",
            "inputUrl": "https://spyne-prod-tech.s3.amazonaws.com/TaD1VC1Ko/eaabbf28/b0c88eea2f0e4afb8749155bd87977ef/2b6a21f3cd604158b6fc37f5f4e7ece9/images/input/hres_5n1dl1gs2nc335977_2b6a21f3cd604158b6fc37f5f4e7ece9_360_exterior_4_2b6a21f3cd604158b6fc37f5f4e7ece9_360_exterior_4.jpg",
            "outputUrl": "https://spyne-media.s3.amazonaws.com/2024-10-22/car_replace_bg_922bb27b-840c-4344-93c4-796ba7d49a1f.jpg"
        },
        {
            "ai_angle": 310,
            "frame_seq_no": "4",
            "imageCategory": "Exterior",
            "image_id": "img-384407bd2c3242668980cff34650e42a",
            "inputUrl": "https://spyne-prod-tech.s3.amazonaws.com/TaD1VC1Ko/eaabbf28/b0c88eea2f0e4afb8749155bd87977ef/2b6a21f3cd604158b6fc37f5f4e7ece9/images/input/hres_5n1dl1gs2nc335977_2b6a21f3cd604158b6fc37f5f4e7ece9_Unclassified_1_2b6a21f3cd604158b6fc37f5f4e7ece9_Unclassified_1.jpg",
            "outputUrl": "https://spyne-media.s3.amazonaws.com/2024-10-22/car_replace_bg_b77cec26-dace-4567-9ff2-faa9f0619f79.jpg"
        },
        {
            "ai_angle": 330,
            "frame_seq_no": "5",
            "imageCategory": "360_exterior",
            "image_id": "img-f548cdd193d94df48edb50e84365fbe6",
            "inputUrl": "https://spyne-prod-tech.s3.amazonaws.com/TaD1VC1Ko/eaabbf28/b0c88eea2f0e4afb8749155bd87977ef/2b6a21f3cd604158b6fc37f5f4e7ece9/images/input/hres_5n1dl1gs2nc335977_2b6a21f3cd604158b6fc37f5f4e7ece9_360_exterior_5_2b6a21f3cd604158b6fc37f5f4e7ece9_360_exterior_5.jpg",
            "outputUrl": "https://spyne-media.s3.amazonaws.com/2024-10-22/car_replace_bg_0184344f-0ffa-41c8-8ffa-60b3c249ef48.jpg"
        },
        {
            "ai_angle": 270,
            "frame_seq_no": "5",
            "imageCategory": "Exterior",
            "image_id": "img-fe812875f3154fcf9a2915cad9b68531",
            "inputUrl": "https://spyne-prod-tech.s3.amazonaws.com/TaD1VC1Ko/eaabbf28/b0c88eea2f0e4afb8749155bd87977ef/2b6a21f3cd604158b6fc37f5f4e7ece9/images/input/hres_5n1dl1gs2nc335977_2b6a21f3cd604158b6fc37f5f4e7ece9_Unclassified_3_2b6a21f3cd604158b6fc37f5f4e7ece9_Unclassified_3.jpg",
            "outputUrl": "https://spyne-media.s3.amazonaws.com/2024-10-22/car_replace_bg_1981efc2-20ca-4f23-9d54-f879bb69f22f.jpg"
        },
        {
            "ai_angle": 330,
            "frame_seq_no": "6",
            "imageCategory": "360_exterior",
            "image_id": "img-0be3d47f227b4e36bdd4a2aac9e59dc4",
            "inputUrl": "https://spyne-prod-tech.s3.amazonaws.com/TaD1VC1Ko/eaabbf28/b0c88eea2f0e4afb8749155bd87977ef/2b6a21f3cd604158b6fc37f5f4e7ece9/images/input/hres_5n1dl1gs2nc335977_2b6a21f3cd604158b6fc37f5f4e7ece9_360_exterior_6_2b6a21f3cd604158b6fc37f5f4e7ece9_360_exterior_6.jpg",
            "outputUrl": "https://spyne-media.s3.amazonaws.com/2024-10-22/car_replace_bg_244f7373-483e-47ab-bce3-0dbc92376047.jpg"
        },
        {
            "ai_angle": 210,
            "frame_seq_no": "6",
            "imageCategory": "Exterior",
            "image_id": "img-dfc06f9c41a448988670910cdc2d5dd7",
            "inputUrl": "https://spyne-prod-tech.s3.amazonaws.com/TaD1VC1Ko/eaabbf28/b0c88eea2f0e4afb8749155bd87977ef/2b6a21f3cd604158b6fc37f5f4e7ece9/images/input/hres_5n1dl1gs2nc335977_2b6a21f3cd604158b6fc37f5f4e7ece9_Unclassified_4_2b6a21f3cd604158b6fc37f5f4e7ece9_Unclassified_4.jpg",
            "outputUrl": "https://spyne-media.s3.amazonaws.com/2024-10-22/car_replace_bg_c786cb6f-b85a-4f51-a894-8e91ee998241.jpg"
        },
        {
            "ai_angle": 340,
            "frame_seq_no": "7",
            "imageCategory": "360_exterior",
            "image_id": "img-1516b293026e43f9b85c246b28a4d74f",
            "inputUrl": "https://spyne-prod-tech.s3.amazonaws.com/TaD1VC1Ko/eaabbf28/b0c88eea2f0e4afb8749155bd87977ef/2b6a21f3cd604158b6fc37f5f4e7ece9/images/input/hres_5n1dl1gs2nc335977_2b6a21f3cd604158b6fc37f5f4e7ece9_360_exterior_7_2b6a21f3cd604158b6fc37f5f4e7ece9_360_exterior_7.jpg",
            "outputUrl": "https://spyne-media.s3.amazonaws.com/2024-10-22/car_replace_bg_11e00961-a7d2-4a3b-b76f-20a844a2c09e.jpg"
        },
        {
            "ai_angle": 180,
            "frame_seq_no": "7",
            "imageCategory": "Exterior",
            "image_id": "img-71f6208faf394914998f94b33024f751",
            "inputUrl": "https://spyne-prod-tech.s3.amazonaws.com/TaD1VC1Ko/eaabbf28/b0c88eea2f0e4afb8749155bd87977ef/2b6a21f3cd604158b6fc37f5f4e7ece9/images/input/hres_5n1dl1gs2nc335977_2b6a21f3cd604158b6fc37f5f4e7ece9_Unclassified_5_2b6a21f3cd604158b6fc37f5f4e7ece9_Unclassified_5.jpg",
            "outputUrl": "https://spyne-media.s3.amazonaws.com/2024-10-22/car_replace_bg_e4addf36-59f2-411b-8551-ef95dafb4275.jpg"
        },
        {
            "ai_angle": 350,
            "frame_seq_no": "8",
            "imageCategory": "360_exterior",
            "image_id": "img-7468d98aaaf141df968fde63c9623b05",
            "inputUrl": "https://spyne-prod-tech.s3.amazonaws.com/TaD1VC1Ko/eaabbf28/b0c88eea2f0e4afb8749155bd87977ef/2b6a21f3cd604158b6fc37f5f4e7ece9/images/input/hres_5n1dl1gs2nc335977_2b6a21f3cd604158b6fc37f5f4e7ece9_360_exterior_8_2b6a21f3cd604158b6fc37f5f4e7ece9_360_exterior_8.jpg",
            "outputUrl": "https://spyne-media.s3.amazonaws.com/2024-10-22/car_replace_bg_8cf67f97-b1f7-4551-a773-0b30e0c35b1a.jpg"
        },
        {
            "ai_angle": 140,
            "frame_seq_no": "8",
            "imageCategory": "Exterior",
            "image_id": "img-b44c2c341ec24e24bc0dcda68b339fcd",
            "inputUrl": "https://spyne-prod-tech.s3.amazonaws.com/TaD1VC1Ko/eaabbf28/b0c88eea2f0e4afb8749155bd87977ef/2b6a21f3cd604158b6fc37f5f4e7ece9/images/input/hres_5n1dl1gs2nc335977_2b6a21f3cd604158b6fc37f5f4e7ece9_Unclassified_6_2b6a21f3cd604158b6fc37f5f4e7ece9_Unclassified_6.jpg",
            "outputUrl": "https://spyne-media.s3.amazonaws.com/2024-10-22/car_replace_bg_41ccabe1-1cec-4d1c-8272-039593c9f90d.jpg"
        },
        {
            "ai_angle": 350,
            "frame_seq_no": "9",
            "imageCategory": "360_exterior",
            "image_id": "img-274b85bc233549139050801f6ce0f3bf",
            "inputUrl": "https://spyne-prod-tech.s3.amazonaws.com/TaD1VC1Ko/eaabbf28/b0c88eea2f0e4afb8749155bd87977ef/2b6a21f3cd604158b6fc37f5f4e7ece9/images/input/hres_5n1dl1gs2nc335977_2b6a21f3cd604158b6fc37f5f4e7ece9_360_exterior_9_2b6a21f3cd604158b6fc37f5f4e7ece9_360_exterior_9.jpg",
            "outputUrl": "https://spyne-media.s3.amazonaws.com/2024-10-22/car_replace_bg_5f39f4e2-9658-4d5a-bffe-129ec13eb6bf.jpg"
        },
        {
            "ai_angle": 80,
            "frame_seq_no": "9",
            "imageCategory": "Exterior",
            "image_id": "img-5bf81780d86a4ca6a4d82c197e1dc868",
            "inputUrl": "https://spyne-prod-tech.s3.amazonaws.com/TaD1VC1Ko/eaabbf28/b0c88eea2f0e4afb8749155bd87977ef/2b6a21f3cd604158b6fc37f5f4e7ece9/images/input/hres_5n1dl1gs2nc335977_2b6a21f3cd604158b6fc37f5f4e7ece9_Unclassified_7_2b6a21f3cd604158b6fc37f5f4e7ece9_Unclassified_7.jpg",
            "outputUrl": "https://spyne-media.s3.amazonaws.com/2024-10-22/car_replace_bg_c27bfca4-f9f3-47fa-bb26-249742c6b2e3.jpg"
        },
        {
            "frame_seq_no": "10",
            "imageCategory": "360int",
            "image_id": "img-dc369a81fc1743458f986c3aa0d89aad",
            "inputUrl": "https://spyne-prod-tech.s3.amazonaws.com/TaD1VC1Ko/eaabbf28/b0c88eea2f0e4afb8749155bd87977ef/2b6a21f3cd604158b6fc37f5f4e7ece9/images/input/hres_5n1dl1gs2nc335977_2b6a21f3cd604158b6fc37f5f4e7ece9_360int_1_2b6a21f3cd604158b6fc37f5f4e7ece9_360int_1.png",
            "outputUrl": "https://spyne-media.s3.amazonaws.com/2024-10-22/car_replace_bg_c305df4c-aec5-49bb-8d60-deb2c9743664.jpg"
        },
        {
            "ai_angle": 350,
            "frame_seq_no": "10",
            "imageCategory": "360_exterior",
            "image_id": "img-bd5e7e8174ce4e50a7721e97a7c394e9",
            "inputUrl": "https://spyne-prod-tech.s3.amazonaws.com/TaD1VC1Ko/eaabbf28/b0c88eea2f0e4afb8749155bd87977ef/2b6a21f3cd604158b6fc37f5f4e7ece9/images/input/hres_5n1dl1gs2nc335977_2b6a21f3cd604158b6fc37f5f4e7ece9_360_exterior_10_2b6a21f3cd604158b6fc37f5f4e7ece9_360_exterior_10.jpg",
            "outputUrl": "https://spyne-media.s3.amazonaws.com/2024-10-22/car_replace_bg_001ee8d8-a5c3-4117-9b2f-72725546e72d.jpg"
        },
        {
            "ai_angle": 0,
            "frame_seq_no": "11",
            "imageCategory": "360_exterior",
            "image_id": "img-598f0447f52a4538b6f8d61e6a1c7ceb",
            "inputUrl": "https://spyne-prod-tech.s3.amazonaws.com/TaD1VC1Ko/eaabbf28/b0c88eea2f0e4afb8749155bd87977ef/2b6a21f3cd604158b6fc37f5f4e7ece9/images/input/hres_5n1dl1gs2nc335977_2b6a21f3cd604158b6fc37f5f4e7ece9_360_exterior_11_2b6a21f3cd604158b6fc37f5f4e7ece9_360_exterior_11.jpg",
            "outputUrl": "https://spyne-media.s3.amazonaws.com/2024-10-22/car_replace_bg_f92a0c3f-5003-4c8b-9e4e-7244da6b53b9.jpg"
        },
        {
            "frame_seq_no": "11",
            "imageCategory": "Miscellaneous",
            "image_id": "img-aaef69017bda4be7a46785599f9f6669",
            "inputUrl": "https://spyne-prod-tech.s3.amazonaws.com/TaD1VC1Ko/eaabbf28/b0c88eea2f0e4afb8749155bd87977ef/2b6a21f3cd604158b6fc37f5f4e7ece9/images/input/hres_5n1dl1gs2nc335977_2b6a21f3cd604158b6fc37f5f4e7ece9_Unclassified_10_2b6a21f3cd604158b6fc37f5f4e7ece9_Unclassified_10.jpg",
            "outputUrl": "https://spyne-media.s3.amazonaws.com/2024-10-22/car_replace_bg_bf0e98f0-8509-43a6-ab4e-8aa3d5fb1078.jpg"
        },
        {
            "ai_angle": 0,
            "frame_seq_no": "12",
            "imageCategory": "360_exterior",
            "image_id": "img-006a968e47fc4548a88230999e241fea",
            "inputUrl": "https://spyne-prod-tech.s3.amazonaws.com/TaD1VC1Ko/eaabbf28/b0c88eea2f0e4afb8749155bd87977ef/2b6a21f3cd604158b6fc37f5f4e7ece9/images/input/hres_5n1dl1gs2nc335977_2b6a21f3cd604158b6fc37f5f4e7ece9_360_exterior_12_2b6a21f3cd604158b6fc37f5f4e7ece9_360_exterior_12.jpg",
            "outputUrl": "https://spyne-media.s3.amazonaws.com/2024-10-22/car_replace_bg_6fd69fcd-cb98-4e2c-9be2-096f109786ed.jpg"
        },
        {
            "frame_seq_no": "12",
            "imageCategory": "Miscellaneous",
            "image_id": "img-2c78c8c53bfd4f369ce9ba575ba3cc17",
            "inputUrl": "https://spyne-prod-tech.s3.amazonaws.com/TaD1VC1Ko/eaabbf28/b0c88eea2f0e4afb8749155bd87977ef/2b6a21f3cd604158b6fc37f5f4e7ece9/images/input/hres_5n1dl1gs2nc335977_2b6a21f3cd604158b6fc37f5f4e7ece9_Unclassified_11_2b6a21f3cd604158b6fc37f5f4e7ece9_Unclassified_11.jpg",
            "outputUrl": "https://spyne-media.s3.amazonaws.com/2024-10-22/car_replace_bg_ad295e61-306d-4277-94ed-930be1275546.jpg"
        },
        {
            "ai_angle": 0,
            "frame_seq_no": "13",
            "imageCategory": "360_exterior",
            "image_id": "img-3cfa207b618f4afc8e63c5c5b6322cf8",
            "inputUrl": "https://spyne-prod-tech.s3.amazonaws.com/TaD1VC1Ko/eaabbf28/b0c88eea2f0e4afb8749155bd87977ef/2b6a21f3cd604158b6fc37f5f4e7ece9/images/input/hres_5n1dl1gs2nc335977_2b6a21f3cd604158b6fc37f5f4e7ece9_360_exterior_13_2b6a21f3cd604158b6fc37f5f4e7ece9_360_exterior_13.jpg",
            "outputUrl": "https://spyne-media.s3.amazonaws.com/2024-10-22/car_replace_bg_b91c5f71-f638-4df0-b30a-81c572028305.jpg"
        },
        {
            "frame_seq_no": "13",
            "imageCategory": "Miscellaneous",
            "image_id": "img-c232a96954724323b0ad0289c3561d79",
            "inputUrl": "https://spyne-prod-tech.s3.amazonaws.com/TaD1VC1Ko/eaabbf28/b0c88eea2f0e4afb8749155bd87977ef/2b6a21f3cd604158b6fc37f5f4e7ece9/images/input/hres_5n1dl1gs2nc335977_2b6a21f3cd604158b6fc37f5f4e7ece9_Unclassified_12_2b6a21f3cd604158b6fc37f5f4e7ece9_Unclassified_12.jpg",
            "outputUrl": "https://spyne-media.s3.amazonaws.com/2024-10-22/car_replace_bg_a253fd65-8cc7-4472-85e0-4a1d12da738e.jpg"
        },
        {
            "ai_angle": 10,
            "frame_seq_no": "14",
            "imageCategory": "360_exterior",
            "image_id": "img-6523ab6caa5845049e8ffe17b57f3769",
            "inputUrl": "https://spyne-prod-tech.s3.amazonaws.com/TaD1VC1Ko/eaabbf28/b0c88eea2f0e4afb8749155bd87977ef/2b6a21f3cd604158b6fc37f5f4e7ece9/images/input/hres_5n1dl1gs2nc335977_2b6a21f3cd604158b6fc37f5f4e7ece9_360_exterior_14_2b6a21f3cd604158b6fc37f5f4e7ece9_360_exterior_14.jpg",
            "outputUrl": "https://spyne-media.s3.amazonaws.com/2024-10-22/car_replace_bg_bd2dec38-b526-403d-a280-85de0cd1d08f.jpg"
        },
        {
            "frame_seq_no": "14",
            "imageCategory": "Interior",
            "image_id": "img-34c2d4b0b40340cab04ce6e1b10a24cf",
            "inputUrl": "https://spyne-prod-tech.s3.amazonaws.com/TaD1VC1Ko/eaabbf28/b0c88eea2f0e4afb8749155bd87977ef/2b6a21f3cd604158b6fc37f5f4e7ece9/images/input/hres_5n1dl1gs2nc335977_2b6a21f3cd604158b6fc37f5f4e7ece9_Unclassified_13_2b6a21f3cd604158b6fc37f5f4e7ece9_Unclassified_13.jpg",
            "outputUrl": "https://spyne-media.s3.amazonaws.com/2024-10-22/car_replace_bg_6898068a-93f7-469e-8905-1e9a71635de4.jpg"
        },
        {
            "ai_angle": 10,
            "frame_seq_no": "15",
            "imageCategory": "360_exterior",
            "image_id": "img-ee4e2bcfae9c491b81a253dd72b4d39b",
            "inputUrl": "https://spyne-prod-tech.s3.amazonaws.com/TaD1VC1Ko/eaabbf28/b0c88eea2f0e4afb8749155bd87977ef/2b6a21f3cd604158b6fc37f5f4e7ece9/images/input/hres_5n1dl1gs2nc335977_2b6a21f3cd604158b6fc37f5f4e7ece9_360_exterior_15_2b6a21f3cd604158b6fc37f5f4e7ece9_360_exterior_15.jpg",
            "outputUrl": "https://spyne-media.s3.amazonaws.com/2024-10-22/car_replace_bg_2d70f0ff-5cb7-47ea-bdd8-d4b3461496dd.jpg"
        },
        {
            "frame_seq_no": "15",
            "imageCategory": "Interior",
            "image_id": "img-13f2c42c01ee42f5a773d045a4a0fe99",
            "inputUrl": "https://spyne-prod-tech.s3.amazonaws.com/TaD1VC1Ko/eaabbf28/b0c88eea2f0e4afb8749155bd87977ef/2b6a21f3cd604158b6fc37f5f4e7ece9/images/input/hres_5n1dl1gs2nc335977_2b6a21f3cd604158b6fc37f5f4e7ece9_Unclassified_14_2b6a21f3cd604158b6fc37f5f4e7ece9_Unclassified_14.jpg",
            "outputUrl": "https://spyne-media.s3.amazonaws.com/2024-10-22/car_replace_bg_1f1754ac-e4de-4b85-9291-876d186de8f6.jpg"
        },
        {
            "ai_angle": 10,
            "frame_seq_no": "16",
            "imageCategory": "360_exterior",
            "image_id": "img-bedb179b3a574e50ad1f614c9e3fc164",
            "inputUrl": "https://spyne-prod-tech.s3.amazonaws.com/TaD1VC1Ko/eaabbf28/b0c88eea2f0e4afb8749155bd87977ef/2b6a21f3cd604158b6fc37f5f4e7ece9/images/input/hres_5n1dl1gs2nc335977_2b6a21f3cd604158b6fc37f5f4e7ece9_360_exterior_16_2b6a21f3cd604158b6fc37f5f4e7ece9_360_exterior_16.jpg",
            "outputUrl": "https://spyne-media.s3.amazonaws.com/2024-10-22/car_replace_bg_80aa2c04-4731-4c10-8ff9-4477f8273dd5.jpg"
        },
        {
            "frame_seq_no": "16",
            "imageCategory": "Interior",
            "image_id": "img-a7a7f22c367d4fdbb91adafc38f5abeb",
            "inputUrl": "https://spyne-prod-tech.s3.amazonaws.com/TaD1VC1Ko/eaabbf28/b0c88eea2f0e4afb8749155bd87977ef/2b6a21f3cd604158b6fc37f5f4e7ece9/images/input/hres_5n1dl1gs2nc335977_2b6a21f3cd604158b6fc37f5f4e7ece9_Unclassified_15_2b6a21f3cd604158b6fc37f5f4e7ece9_Unclassified_15.jpg",
            "outputUrl": "https://spyne-media.s3.amazonaws.com/2024-10-22/car_replace_bg_0f15a2d9-cb97-44a6-9637-7deae7d6d2b1.jpg"
        },
        {
            "ai_angle": 20,
            "frame_seq_no": "17",
            "imageCategory": "360_exterior",
            "image_id": "img-1dacdd9fd92343cfb0dde23bc89a1fd0",
            "inputUrl": "https://spyne-prod-tech.s3.amazonaws.com/TaD1VC1Ko/eaabbf28/b0c88eea2f0e4afb8749155bd87977ef/2b6a21f3cd604158b6fc37f5f4e7ece9/images/input/hres_5n1dl1gs2nc335977_2b6a21f3cd604158b6fc37f5f4e7ece9_360_exterior_17_2b6a21f3cd604158b6fc37f5f4e7ece9_360_exterior_17.jpg",
            "outputUrl": "https://spyne-media.s3.amazonaws.com/2024-10-22/car_replace_bg_2d6f9162-d46f-487b-8b51-44c1aad0836e.jpg"
        },
        {
            "frame_seq_no": "17",
            "imageCategory": "Interior",
            "image_id": "img-e06fbb9a12af43bd9bd227e3603f872b",
            "inputUrl": "https://spyne-prod-tech.s3.amazonaws.com/TaD1VC1Ko/eaabbf28/b0c88eea2f0e4afb8749155bd87977ef/2b6a21f3cd604158b6fc37f5f4e7ece9/images/input/hres_5n1dl1gs2nc335977_2b6a21f3cd604158b6fc37f5f4e7ece9_Unclassified_16_2b6a21f3cd604158b6fc37f5f4e7ece9_Unclassified_16.jpg",
            "outputUrl": "https://spyne-media.s3.amazonaws.com/2024-10-22/car_replace_bg_2b47ab67-5111-4c92-b1b5-4c0d3f0aa943.jpg"
        },
        {
            "ai_angle": 20,
            "frame_seq_no": "18",
            "imageCategory": "360_exterior",
            "image_id": "img-30c78efab6bb450fb2351d6f849b32b9",
            "inputUrl": "https://spyne-prod-tech.s3.amazonaws.com/TaD1VC1Ko/eaabbf28/b0c88eea2f0e4afb8749155bd87977ef/2b6a21f3cd604158b6fc37f5f4e7ece9/images/input/hres_5n1dl1gs2nc335977_2b6a21f3cd604158b6fc37f5f4e7ece9_360_exterior_18_2b6a21f3cd604158b6fc37f5f4e7ece9_360_exterior_18.jpg",
            "outputUrl": "https://spyne-media.s3.amazonaws.com/2024-10-22/car_replace_bg_9d059107-ded6-45f3-8970-6c5de5d6c888.jpg"
        },
        {
            "frame_seq_no": "18",
            "imageCategory": "Interior",
            "image_id": "img-d5ad94cac5f54376b96b41449d187e0a",
            "inputUrl": "https://spyne-prod-tech.s3.amazonaws.com/TaD1VC1Ko/eaabbf28/b0c88eea2f0e4afb8749155bd87977ef/2b6a21f3cd604158b6fc37f5f4e7ece9/images/input/hres_5n1dl1gs2nc335977_2b6a21f3cd604158b6fc37f5f4e7ece9_Unclassified_17_2b6a21f3cd604158b6fc37f5f4e7ece9_Unclassified_17.jpg",
            "outputUrl": "https://spyne-media.s3.amazonaws.com/2024-10-22/car_replace_bg_312d1986-a4ee-4678-ba11-4170524a29a2.jpg"
        },
        {
            "frame_seq_no": "19",
            "imageCategory": "Interior",
            "image_id": "img-39d9e4aa8f2048ad8039a50d198d154c",
            "inputUrl": "https://spyne-prod-tech.s3.amazonaws.com/TaD1VC1Ko/eaabbf28/b0c88eea2f0e4afb8749155bd87977ef/2b6a21f3cd604158b6fc37f5f4e7ece9/images/input/hres_5n1dl1gs2nc335977_2b6a21f3cd604158b6fc37f5f4e7ece9_Unclassified_18_2b6a21f3cd604158b6fc37f5f4e7ece9_Unclassified_18.jpg",
            "outputUrl": "https://spyne-media.s3.amazonaws.com/2024-10-22/car_replace_bg_d0efc5c0-25f6-4688-ac17-8daa6c971cd4.jpg"
        },
        {
            "frame_seq_no": "20",
            "imageCategory": "Interior",
            "image_id": "img-6956f8b73f0c4220bdd303634b35a2a0",
            "inputUrl": "https://spyne-prod-tech.s3.amazonaws.com/TaD1VC1Ko/eaabbf28/b0c88eea2f0e4afb8749155bd87977ef/2b6a21f3cd604158b6fc37f5f4e7ece9/images/input/hres_5n1dl1gs2nc335977_2b6a21f3cd604158b6fc37f5f4e7ece9_Unclassified_19_2b6a21f3cd604158b6fc37f5f4e7ece9_Unclassified_19.jpg",
            "outputUrl": "https://spyne-media.s3.amazonaws.com/2024-10-22/car_replace_bg_c00317c0-a83a-471c-9706-86daa8724daa.jpg"
        },
        {
            "frame_seq_no": "21",
            "imageCategory": "Interior",
            "image_id": "img-e2b84610659241ce87ee8ab863835b7f",
            "inputUrl": "https://spyne-prod-tech.s3.amazonaws.com/TaD1VC1Ko/eaabbf28/b0c88eea2f0e4afb8749155bd87977ef/2b6a21f3cd604158b6fc37f5f4e7ece9/images/input/hres_5n1dl1gs2nc335977_2b6a21f3cd604158b6fc37f5f4e7ece9_Unclassified_20_2b6a21f3cd604158b6fc37f5f4e7ece9_Unclassified_20.jpg",
            "outputUrl": "https://spyne-media.s3.amazonaws.com/2024-10-22/car_replace_bg_e4b0449f-fb07-4108-bf82-121e9f110297.jpg"
        },
        {
            "frame_seq_no": "22",
            "imageCategory": "Interior",
            "image_id": "img-2515f58955d14a3a8f9e1eaf87be9fba",
            "inputUrl": "https://spyne-prod-tech.s3.amazonaws.com/TaD1VC1Ko/eaabbf28/b0c88eea2f0e4afb8749155bd87977ef/2b6a21f3cd604158b6fc37f5f4e7ece9/images/input/hres_5n1dl1gs2nc335977_2b6a21f3cd604158b6fc37f5f4e7ece9_Unclassified_21_2b6a21f3cd604158b6fc37f5f4e7ece9_Unclassified_21.jpg",
            "outputUrl": "https://spyne-media.s3.amazonaws.com/2024-10-22/car_replace_bg_3d6acdbe-cd99-4485-8b7b-a7988b2f348c.jpg"
        },
        {
            "frame_seq_no": "23",
            "imageCategory": "Interior",
            "image_id": "img-efb85f8f0ef146c39bfa774a7ccf8759",
            "inputUrl": "https://spyne-prod-tech.s3.amazonaws.com/TaD1VC1Ko/eaabbf28/b0c88eea2f0e4afb8749155bd87977ef/2b6a21f3cd604158b6fc37f5f4e7ece9/images/input/hres_5n1dl1gs2nc335977_2b6a21f3cd604158b6fc37f5f4e7ece9_Unclassified_22_2b6a21f3cd604158b6fc37f5f4e7ece9_Unclassified_22.jpg",
            "outputUrl": "https://spyne-media.s3.amazonaws.com/2024-10-22/car_replace_bg_c8359986-40e7-42e3-a7d2-dff11e90489b.jpg"
        },
        {
            "frame_seq_no": "24",
            "imageCategory": "Interior",
            "image_id": "img-df83fc185f6d4cacb179b673654c6b29",
            "inputUrl": "https://spyne-prod-tech.s3.amazonaws.com/TaD1VC1Ko/eaabbf28/b0c88eea2f0e4afb8749155bd87977ef/2b6a21f3cd604158b6fc37f5f4e7ece9/images/input/hres_5n1dl1gs2nc335977_2b6a21f3cd604158b6fc37f5f4e7ece9_Unclassified_23_2b6a21f3cd604158b6fc37f5f4e7ece9_Unclassified_23.jpg",
            "outputUrl": "https://spyne-media.s3.amazonaws.com/2024-10-22/car_replace_bg_f0afcbbb-318d-46dd-b9ff-4ecfaf7b901b.jpg"
        },
        {
            "frame_seq_no": "25",
            "imageCategory": "Interior",
            "image_id": "img-3886eb1f3aa84b01bcf0bd155d107454",
            "inputUrl": "https://spyne-prod-tech.s3.amazonaws.com/TaD1VC1Ko/eaabbf28/b0c88eea2f0e4afb8749155bd87977ef/2b6a21f3cd604158b6fc37f5f4e7ece9/images/input/hres_5n1dl1gs2nc335977_2b6a21f3cd604158b6fc37f5f4e7ece9_Unclassified_24_2b6a21f3cd604158b6fc37f5f4e7ece9_Unclassified_24.jpg",
            "outputUrl": "https://spyne-media.s3.amazonaws.com/2024-10-22/car_replace_bg_28906f88-6187-4d1b-ac48-12213ca7506e.jpg"
        },
        {
            "ai_angle": 60,
            "frame_seq_no": "26",
            "imageCategory": "360_exterior",
            "image_id": "img-56379a0b689d4e59875c40accd655800",
            "inputUrl": "https://spyne-prod-tech.s3.amazonaws.com/TaD1VC1Ko/eaabbf28/b0c88eea2f0e4afb8749155bd87977ef/2b6a21f3cd604158b6fc37f5f4e7ece9/images/input/hres_5n1dl1gs2nc335977_2b6a21f3cd604158b6fc37f5f4e7ece9_360_exterior_26_2b6a21f3cd604158b6fc37f5f4e7ece9_360_exterior_26.jpg",
            "outputUrl": "https://spyne-media.s3.amazonaws.com/2024-10-22/car_replace_bg_396b1282-8e36-499c-90bc-805e1a6b7743.jpg"
        },
        {
            "frame_seq_no": "26",
            "imageCategory": "Interior",
            "image_id": "img-3dc1ea1212044380bf187e73a513bde8",
            "inputUrl": "https://spyne-prod-tech.s3.amazonaws.com/TaD1VC1Ko/eaabbf28/b0c88eea2f0e4afb8749155bd87977ef/2b6a21f3cd604158b6fc37f5f4e7ece9/images/input/hres_5n1dl1gs2nc335977_2b6a21f3cd604158b6fc37f5f4e7ece9_Unclassified_25_2b6a21f3cd604158b6fc37f5f4e7ece9_Unclassified_25.jpg",
            "outputUrl": "https://spyne-media.s3.amazonaws.com/2024-10-22/car_replace_bg_3d888ad6-251e-49d2-a376-10f99bd35b4a.jpg"
        },
        {
            "ai_angle": 60,
            "frame_seq_no": "27",
            "imageCategory": "360_exterior",
            "image_id": "img-957677665a42497f983cef1bc4b10319",
            "inputUrl": "https://spyne-prod-tech.s3.amazonaws.com/TaD1VC1Ko/eaabbf28/b0c88eea2f0e4afb8749155bd87977ef/2b6a21f3cd604158b6fc37f5f4e7ece9/images/input/hres_5n1dl1gs2nc335977_2b6a21f3cd604158b6fc37f5f4e7ece9_360_exterior_27_2b6a21f3cd604158b6fc37f5f4e7ece9_360_exterior_27.jpg",
            "outputUrl": "https://spyne-media.s3.amazonaws.com/2024-10-22/car_replace_bg_b7c3726c-f5b5-4bf1-b3e0-2006b7ccf04c.jpg"
        },
        {
            "frame_seq_no": "27",
            "imageCategory": "Interior",
            "image_id": "img-58213c6ede7544b3a77b5cc41c94cca7",
            "inputUrl": "https://spyne-prod-tech.s3.amazonaws.com/TaD1VC1Ko/eaabbf28/b0c88eea2f0e4afb8749155bd87977ef/2b6a21f3cd604158b6fc37f5f4e7ece9/images/input/hres_5n1dl1gs2nc335977_2b6a21f3cd604158b6fc37f5f4e7ece9_Unclassified_26_2b6a21f3cd604158b6fc37f5f4e7ece9_Unclassified_26.jpg",
            "outputUrl": "https://spyne-media.s3.amazonaws.com/2024-10-22/car_replace_bg_7fabbd4e-7822-4a06-8237-279292e11d5b.jpg"
        },
        {
            "ai_angle": 60,
            "frame_seq_no": "28",
            "imageCategory": "360_exterior",
            "image_id": "img-b3829c9a0c8340ce8eb0f14e23ff2526",
            "inputUrl": "https://spyne-prod-tech.s3.amazonaws.com/TaD1VC1Ko/eaabbf28/b0c88eea2f0e4afb8749155bd87977ef/2b6a21f3cd604158b6fc37f5f4e7ece9/images/input/hres_5n1dl1gs2nc335977_2b6a21f3cd604158b6fc37f5f4e7ece9_360_exterior_28_2b6a21f3cd604158b6fc37f5f4e7ece9_360_exterior_28.jpg",
            "outputUrl": "https://spyne-media.s3.amazonaws.com/2024-10-22/car_replace_bg_cdc3dc64-09d4-47c0-bdd0-48b87a42ff4d.jpg"
        },
        {
            "frame_seq_no": "28",
            "imageCategory": "Interior",
            "image_id": "img-56dad664fefd43a2a84b9b479d18941c",
            "inputUrl": "https://spyne-prod-tech.s3.amazonaws.com/TaD1VC1Ko/eaabbf28/b0c88eea2f0e4afb8749155bd87977ef/2b6a21f3cd604158b6fc37f5f4e7ece9/images/input/hres_5n1dl1gs2nc335977_2b6a21f3cd604158b6fc37f5f4e7ece9_Unclassified_27_2b6a21f3cd604158b6fc37f5f4e7ece9_Unclassified_27.jpg",
            "outputUrl": "https://spyne-media.s3.amazonaws.com/2024-10-22/car_replace_bg_ca43ede6-4b95-428e-8312-d35fdaa2a75f.jpg"
        },
        {
            "ai_angle": 70,
            "frame_seq_no": "29",
            "imageCategory": "360_exterior",
            "image_id": "img-9f62080ea3674858a6cb45069eaa6731",
            "inputUrl": "https://spyne-prod-tech.s3.amazonaws.com/TaD1VC1Ko/eaabbf28/b0c88eea2f0e4afb8749155bd87977ef/2b6a21f3cd604158b6fc37f5f4e7ece9/images/input/hres_5n1dl1gs2nc335977_2b6a21f3cd604158b6fc37f5f4e7ece9_360_exterior_29_2b6a21f3cd604158b6fc37f5f4e7ece9_360_exterior_29.jpg",
            "outputUrl": "https://spyne-media.s3.amazonaws.com/2024-10-22/car_replace_bg_452122bd-f95b-44a5-b4b3-32b734800e17.jpg"
        },
        {
            "frame_seq_no": "29",
            "imageCategory": "Interior",
            "image_id": "img-e2fb9fc0e93e4b48a8db749d4db0291f",
            "inputUrl": "https://spyne-prod-tech.s3.amazonaws.com/TaD1VC1Ko/eaabbf28/b0c88eea2f0e4afb8749155bd87977ef/2b6a21f3cd604158b6fc37f5f4e7ece9/images/input/hres_5n1dl1gs2nc335977_2b6a21f3cd604158b6fc37f5f4e7ece9_Unclassified_28_2b6a21f3cd604158b6fc37f5f4e7ece9_Unclassified_28.jpg",
            "outputUrl": "https://spyne-media.s3.amazonaws.com/2024-10-22/car_replace_bg_04b51082-47cd-4084-ba46-07e9203b39d5.jpg"
        },
        {
            "ai_angle": 70,
            "frame_seq_no": "30",
            "imageCategory": "360_exterior",
            "image_id": "img-6e3b3630df4a4de8889852fc38c1f677",
            "inputUrl": "https://spyne-prod-tech.s3.amazonaws.com/TaD1VC1Ko/eaabbf28/b0c88eea2f0e4afb8749155bd87977ef/2b6a21f3cd604158b6fc37f5f4e7ece9/images/input/hres_5n1dl1gs2nc335977_2b6a21f3cd604158b6fc37f5f4e7ece9_360_exterior_30_2b6a21f3cd604158b6fc37f5f4e7ece9_360_exterior_30.jpg",
            "outputUrl": "https://spyne-media.s3.amazonaws.com/2024-10-22/car_replace_bg_4ef39d61-c5b9-416c-81c8-f0971d59ac08.jpg"
        },
        {
            "frame_seq_no": "30",
            "imageCategory": "Interior",
            "image_id": "img-fcbcdd65385240068661a55d6f2fea00",
            "inputUrl": "https://spyne-prod-tech.s3.amazonaws.com/TaD1VC1Ko/eaabbf28/b0c88eea2f0e4afb8749155bd87977ef/2b6a21f3cd604158b6fc37f5f4e7ece9/images/input/hres_5n1dl1gs2nc335977_2b6a21f3cd604158b6fc37f5f4e7ece9_Unclassified_29_2b6a21f3cd604158b6fc37f5f4e7ece9_Unclassified_29.jpg",
            "outputUrl": "https://spyne-media.s3.amazonaws.com/2024-10-22/car_replace_bg_7a826cb7-5415-45c7-81bf-843834fc5316.jpg"
        },
        {
            "ai_angle": 70,
            "frame_seq_no": "31",
            "imageCategory": "360_exterior",
            "image_id": "img-46e802e2b5c7457c8d9fee297ec9e8db",
            "inputUrl": "https://spyne-prod-tech.s3.amazonaws.com/TaD1VC1Ko/eaabbf28/b0c88eea2f0e4afb8749155bd87977ef/2b6a21f3cd604158b6fc37f5f4e7ece9/images/input/hres_5n1dl1gs2nc335977_2b6a21f3cd604158b6fc37f5f4e7ece9_360_exterior_31_2b6a21f3cd604158b6fc37f5f4e7ece9_360_exterior_31.jpg",
            "outputUrl": "https://spyne-media.s3.amazonaws.com/2024-10-22/car_replace_bg_190b5aee-787b-42bf-9107-2520452da37c.jpg"
        },
        {
            "frame_seq_no": "31",
            "imageCategory": "Interior",
            "image_id": "img-c7a9469265ac48d2bc3ce4553e423170",
            "inputUrl": "https://spyne-prod-tech.s3.amazonaws.com/TaD1VC1Ko/eaabbf28/b0c88eea2f0e4afb8749155bd87977ef/2b6a21f3cd604158b6fc37f5f4e7ece9/images/input/hres_5n1dl1gs2nc335977_2b6a21f3cd604158b6fc37f5f4e7ece9_Unclassified_30_2b6a21f3cd604158b6fc37f5f4e7ece9_Unclassified_30.jpg",
            "outputUrl": "https://spyne-media.s3.amazonaws.com/2024-10-22/694df271-fb6b-4ec8-92f7-5902a4f5291e.jpeg"
        },
        {
            "ai_angle": 80,
            "frame_seq_no": "32",
            "imageCategory": "360_exterior",
            "image_id": "img-d4edf8e941d84bdfabe4534c9b022a42",
            "inputUrl": "https://spyne-prod-tech.s3.amazonaws.com/TaD1VC1Ko/eaabbf28/b0c88eea2f0e4afb8749155bd87977ef/2b6a21f3cd604158b6fc37f5f4e7ece9/images/input/hres_5n1dl1gs2nc335977_2b6a21f3cd604158b6fc37f5f4e7ece9_360_exterior_32_2b6a21f3cd604158b6fc37f5f4e7ece9_360_exterior_32.jpg",
            "outputUrl": "https://spyne-media.s3.amazonaws.com/2024-10-22/car_replace_bg_7ce41588-7ac5-4ef9-9fff-5a4428bec565.jpg"
        },
        {
            "ai_angle": 80,
            "frame_seq_no": "33",
            "imageCategory": "360_exterior",
            "image_id": "img-36bd46066a7c4517b9533848935b3bf7",
            "inputUrl": "https://spyne-prod-tech.s3.amazonaws.com/TaD1VC1Ko/eaabbf28/b0c88eea2f0e4afb8749155bd87977ef/2b6a21f3cd604158b6fc37f5f4e7ece9/images/input/hres_5n1dl1gs2nc335977_2b6a21f3cd604158b6fc37f5f4e7ece9_360_exterior_33_2b6a21f3cd604158b6fc37f5f4e7ece9_360_exterior_33.jpg",
            "outputUrl": "https://spyne-media.s3.amazonaws.com/2024-10-22/car_replace_bg_ffaa5eed-508a-4c79-8b28-b13bbc490098.jpg"
        },
        {
            "ai_angle": 80,
            "frame_seq_no": "34",
            "imageCategory": "360_exterior",
            "image_id": "img-29bc1caf070648e884b30c55df21ac7f",
            "inputUrl": "https://spyne-prod-tech.s3.amazonaws.com/TaD1VC1Ko/eaabbf28/b0c88eea2f0e4afb8749155bd87977ef/2b6a21f3cd604158b6fc37f5f4e7ece9/images/input/hres_5n1dl1gs2nc335977_2b6a21f3cd604158b6fc37f5f4e7ece9_360_exterior_34_2b6a21f3cd604158b6fc37f5f4e7ece9_360_exterior_34.jpg",
            "outputUrl": "https://spyne-media.s3.amazonaws.com/2024-10-22/car_replace_bg_9d40685e-42bb-418f-bce6-ef581d5b5f53.jpg"
        },
        {
            "ai_angle": 90,
            "frame_seq_no": "35",
            "imageCategory": "360_exterior",
            "image_id": "img-2fe995cdc0ab4062bb5d10fd209853f5",
            "inputUrl": "https://spyne-prod-tech.s3.amazonaws.com/TaD1VC1Ko/eaabbf28/b0c88eea2f0e4afb8749155bd87977ef/2b6a21f3cd604158b6fc37f5f4e7ece9/images/input/hres_5n1dl1gs2nc335977_2b6a21f3cd604158b6fc37f5f4e7ece9_360_exterior_35_2b6a21f3cd604158b6fc37f5f4e7ece9_360_exterior_35.jpg",
            "outputUrl": "https://spyne-media.s3.amazonaws.com/2024-10-22/car_replace_bg_ad84adeb-df45-47d5-9216-dc889524e53b.jpg"
        },
        {
            "ai_angle": 90,
            "frame_seq_no": "36",
            "imageCategory": "360_exterior",
            "image_id": "img-cd586bf0214f43a391f98a41cb67a18a",
            "inputUrl": "https://spyne-prod-tech.s3.amazonaws.com/TaD1VC1Ko/eaabbf28/b0c88eea2f0e4afb8749155bd87977ef/2b6a21f3cd604158b6fc37f5f4e7ece9/images/input/hres_5n1dl1gs2nc335977_2b6a21f3cd604158b6fc37f5f4e7ece9_360_exterior_36_2b6a21f3cd604158b6fc37f5f4e7ece9_360_exterior_36.jpg",
            "outputUrl": "https://spyne-media.s3.amazonaws.com/2024-10-22/car_replace_bg_ee117829-f36f-438e-82ff-419a340c642e.jpg"
        },
        {
            "ai_angle": 100,
            "frame_seq_no": "37",
            "imageCategory": "360_exterior",
            "image_id": "img-760575813300472c97aa42cc65ebd559",
            "inputUrl": "https://spyne-prod-tech.s3.amazonaws.com/TaD1VC1Ko/eaabbf28/b0c88eea2f0e4afb8749155bd87977ef/2b6a21f3cd604158b6fc37f5f4e7ece9/images/input/hres_5n1dl1gs2nc335977_2b6a21f3cd604158b6fc37f5f4e7ece9_360_exterior_37_2b6a21f3cd604158b6fc37f5f4e7ece9_360_exterior_37.jpg",
            "outputUrl": "https://spyne-media.s3.amazonaws.com/2024-10-22/car_replace_bg_7d139500-0e0f-45c2-a904-3b444487e359.jpg"
        },
        {
            "ai_angle": 100,
            "frame_seq_no": "38",
            "imageCategory": "360_exterior",
            "image_id": "img-9d5769a676be4631807e360d3471e1f8",
            "inputUrl": "https://spyne-prod-tech.s3.amazonaws.com/TaD1VC1Ko/eaabbf28/b0c88eea2f0e4afb8749155bd87977ef/2b6a21f3cd604158b6fc37f5f4e7ece9/images/input/hres_5n1dl1gs2nc335977_2b6a21f3cd604158b6fc37f5f4e7ece9_360_exterior_38_2b6a21f3cd604158b6fc37f5f4e7ece9_360_exterior_38.jpg",
            "outputUrl": "https://spyne-media.s3.amazonaws.com/2024-10-22/car_replace_bg_154185ca-abf6-4744-a1c2-d090dd99466b.jpg"
        },
        {
            "ai_angle": 110,
            "frame_seq_no": "39",
            "imageCategory": "360_exterior",
            "image_id": "img-40d8ade003e74c5ba16955c356eb9564",
            "inputUrl": "https://spyne-prod-tech.s3.amazonaws.com/TaD1VC1Ko/eaabbf28/b0c88eea2f0e4afb8749155bd87977ef/2b6a21f3cd604158b6fc37f5f4e7ece9/images/input/hres_5n1dl1gs2nc335977_2b6a21f3cd604158b6fc37f5f4e7ece9_360_exterior_39_2b6a21f3cd604158b6fc37f5f4e7ece9_360_exterior_39.jpg",
            "outputUrl": "https://spyne-media.s3.amazonaws.com/2024-10-22/car_replace_bg_74a8b5b3-5f88-48f2-967c-4776474d87c9.jpg"
        },
        {
            "ai_angle": 110,
            "frame_seq_no": "40",
            "imageCategory": "360_exterior",
            "image_id": "img-e6b42fbdff6045bd8ef1c22ed143731d",
            "inputUrl": "https://spyne-prod-tech.s3.amazonaws.com/TaD1VC1Ko/eaabbf28/b0c88eea2f0e4afb8749155bd87977ef/2b6a21f3cd604158b6fc37f5f4e7ece9/images/input/hres_5n1dl1gs2nc335977_2b6a21f3cd604158b6fc37f5f4e7ece9_360_exterior_40_2b6a21f3cd604158b6fc37f5f4e7ece9_360_exterior_40.jpg",
            "outputUrl": "https://spyne-media.s3.amazonaws.com/2024-10-22/car_replace_bg_37c997b4-9b21-4d99-8ec5-b95aea9a615d.jpg"
        },
        {
            "ai_angle": 110,
            "frame_seq_no": "41",
            "imageCategory": "360_exterior",
            "image_id": "img-474bc7d97ab24d0fa4f788e783ef0a14",
            "inputUrl": "https://spyne-prod-tech.s3.amazonaws.com/TaD1VC1Ko/eaabbf28/b0c88eea2f0e4afb8749155bd87977ef/2b6a21f3cd604158b6fc37f5f4e7ece9/images/input/hres_5n1dl1gs2nc335977_2b6a21f3cd604158b6fc37f5f4e7ece9_360_exterior_41_2b6a21f3cd604158b6fc37f5f4e7ece9_360_exterior_41.jpg",
            "outputUrl": "https://spyne-media.s3.amazonaws.com/2024-10-22/car_replace_bg_890a8e47-8a78-452d-b15b-a9d44dd31ccb.jpg"
        },
        {
            "ai_angle": 120,
            "frame_seq_no": "42",
            "imageCategory": "360_exterior",
            "image_id": "img-418f9c56a6f441d390b8f3f88cd5bc82",
            "inputUrl": "https://spyne-prod-tech.s3.amazonaws.com/TaD1VC1Ko/eaabbf28/b0c88eea2f0e4afb8749155bd87977ef/2b6a21f3cd604158b6fc37f5f4e7ece9/images/input/hres_5n1dl1gs2nc335977_2b6a21f3cd604158b6fc37f5f4e7ece9_360_exterior_42_2b6a21f3cd604158b6fc37f5f4e7ece9_360_exterior_42.jpg",
            "outputUrl": "https://spyne-media.s3.amazonaws.com/2024-10-22/car_replace_bg_e9cad5e8-73bd-44fc-96bd-a5cc176a60c6.jpg"
        },
        {
            "ai_angle": 120,
            "frame_seq_no": "43",
            "imageCategory": "360_exterior",
            "image_id": "img-41f81e3d31054928ae6065d1a5572562",
            "inputUrl": "https://spyne-prod-tech.s3.amazonaws.com/TaD1VC1Ko/eaabbf28/b0c88eea2f0e4afb8749155bd87977ef/2b6a21f3cd604158b6fc37f5f4e7ece9/images/input/hres_5n1dl1gs2nc335977_2b6a21f3cd604158b6fc37f5f4e7ece9_360_exterior_43_2b6a21f3cd604158b6fc37f5f4e7ece9_360_exterior_43.jpg",
            "outputUrl": "https://spyne-media.s3.amazonaws.com/2024-10-22/car_replace_bg_41475829-c225-49f5-9815-8f4bd6a393ec.jpg"
        },
        {
            "ai_angle": 120,
            "frame_seq_no": "44",
            "imageCategory": "360_exterior",
            "image_id": "img-7677fa78ed13483ba099d01206b9b8d6",
            "inputUrl": "https://spyne-prod-tech.s3.amazonaws.com/TaD1VC1Ko/eaabbf28/b0c88eea2f0e4afb8749155bd87977ef/2b6a21f3cd604158b6fc37f5f4e7ece9/images/input/hres_5n1dl1gs2nc335977_2b6a21f3cd604158b6fc37f5f4e7ece9_360_exterior_44_2b6a21f3cd604158b6fc37f5f4e7ece9_360_exterior_44.jpg",
            "outputUrl": "https://spyne-media.s3.amazonaws.com/2024-10-22/car_replace_bg_2c744dc5-c38b-4e8e-ad8e-8c4795d81bea.jpg"
        },
        {
            "ai_angle": 130,
            "frame_seq_no": "45",
            "imageCategory": "360_exterior",
            "image_id": "img-155706e8c0364a3e8ec8e0bea3227478",
            "inputUrl": "https://spyne-prod-tech.s3.amazonaws.com/TaD1VC1Ko/eaabbf28/b0c88eea2f0e4afb8749155bd87977ef/2b6a21f3cd604158b6fc37f5f4e7ece9/images/input/hres_5n1dl1gs2nc335977_2b6a21f3cd604158b6fc37f5f4e7ece9_360_exterior_45_2b6a21f3cd604158b6fc37f5f4e7ece9_360_exterior_45.jpg",
            "outputUrl": "https://spyne-media.s3.amazonaws.com/2024-10-22/car_replace_bg_5dc19d4b-6b8c-4447-8d3f-883c043ca954.jpg"
        },
        {
            "ai_angle": 130,
            "frame_seq_no": "46",
            "imageCategory": "360_exterior",
            "image_id": "img-7e6e2fe448444be287389742d93b9b7b",
            "inputUrl": "https://spyne-prod-tech.s3.amazonaws.com/TaD1VC1Ko/eaabbf28/b0c88eea2f0e4afb8749155bd87977ef/2b6a21f3cd604158b6fc37f5f4e7ece9/images/input/hres_5n1dl1gs2nc335977_2b6a21f3cd604158b6fc37f5f4e7ece9_360_exterior_46_2b6a21f3cd604158b6fc37f5f4e7ece9_360_exterior_46.jpg",
            "outputUrl": "https://spyne-media.s3.amazonaws.com/2024-10-22/car_replace_bg_3e0d1ab3-84f1-4f1b-a37b-f03358a6a2c6.jpg"
        },
        {
            "ai_angle": 140,
            "frame_seq_no": "47",
            "imageCategory": "360_exterior",
            "image_id": "img-a85bd9dffd9348d68f52ee1d972e4280",
            "inputUrl": "https://spyne-prod-tech.s3.amazonaws.com/TaD1VC1Ko/eaabbf28/b0c88eea2f0e4afb8749155bd87977ef/2b6a21f3cd604158b6fc37f5f4e7ece9/images/input/hres_5n1dl1gs2nc335977_2b6a21f3cd604158b6fc37f5f4e7ece9_360_exterior_47_2b6a21f3cd604158b6fc37f5f4e7ece9_360_exterior_47.jpg",
            "outputUrl": "https://spyne-media.s3.amazonaws.com/2024-10-22/car_replace_bg_6889c332-2370-4de2-84d4-e7e54981d9c3.jpg"
        },
        {
            "ai_angle": 140,
            "frame_seq_no": "48",
            "imageCategory": "360_exterior",
            "image_id": "img-86be2b1dc2a0407f8531630a69423fca",
            "inputUrl": "https://spyne-prod-tech.s3.amazonaws.com/TaD1VC1Ko/eaabbf28/b0c88eea2f0e4afb8749155bd87977ef/2b6a21f3cd604158b6fc37f5f4e7ece9/images/input/hres_5n1dl1gs2nc335977_2b6a21f3cd604158b6fc37f5f4e7ece9_360_exterior_48_2b6a21f3cd604158b6fc37f5f4e7ece9_360_exterior_48.jpg",
            "outputUrl": "https://spyne-media.s3.amazonaws.com/2024-10-22/car_replace_bg_5d29e1aa-bffb-45a5-9e65-ee755a46671f.jpg"
        },
        {
            "ai_angle": 140,
            "frame_seq_no": "49",
            "imageCategory": "360_exterior",
            "image_id": "img-15eb66674ba04d93a663b7df28054a6d",
            "inputUrl": "https://spyne-prod-tech.s3.amazonaws.com/TaD1VC1Ko/eaabbf28/b0c88eea2f0e4afb8749155bd87977ef/2b6a21f3cd604158b6fc37f5f4e7ece9/images/input/hres_5n1dl1gs2nc335977_2b6a21f3cd604158b6fc37f5f4e7ece9_360_exterior_49_2b6a21f3cd604158b6fc37f5f4e7ece9_360_exterior_49.jpg",
            "outputUrl": "https://spyne-media.s3.amazonaws.com/2024-10-22/car_replace_bg_b35dbe1b-dcfa-49e0-8faf-937bc9531345.jpg"
        },
        {
            "ai_angle": 150,
            "frame_seq_no": "50",
            "imageCategory": "360_exterior",
            "image_id": "img-511549504e864248bfbac4bb773b815a",
            "inputUrl": "https://spyne-prod-tech.s3.amazonaws.com/TaD1VC1Ko/eaabbf28/b0c88eea2f0e4afb8749155bd87977ef/2b6a21f3cd604158b6fc37f5f4e7ece9/images/input/hres_5n1dl1gs2nc335977_2b6a21f3cd604158b6fc37f5f4e7ece9_360_exterior_50_2b6a21f3cd604158b6fc37f5f4e7ece9_360_exterior_50.jpg",
            "outputUrl": "https://spyne-media.s3.amazonaws.com/2024-10-22/car_replace_bg_1ca81a93-27ba-4b9b-ac9a-ee64034e3583.jpg"
        },
        {
            "ai_angle": 150,
            "frame_seq_no": "51",
            "imageCategory": "360_exterior",
            "image_id": "img-31e0537957674718a2d67a3a60963621",
            "inputUrl": "https://spyne-prod-tech.s3.amazonaws.com/TaD1VC1Ko/eaabbf28/b0c88eea2f0e4afb8749155bd87977ef/2b6a21f3cd604158b6fc37f5f4e7ece9/images/input/hres_5n1dl1gs2nc335977_2b6a21f3cd604158b6fc37f5f4e7ece9_360_exterior_51_2b6a21f3cd604158b6fc37f5f4e7ece9_360_exterior_51.jpg",
            "outputUrl": "https://spyne-media.s3.amazonaws.com/2024-10-22/car_replace_bg_228b20e0-d2d8-47de-8b1c-10d8c69e71ba.jpg"
        },
        {
            "ai_angle": 160,
            "frame_seq_no": "52",
            "imageCategory": "360_exterior",
            "image_id": "img-0c5189c035064ed1817056f4b48e4545",
            "inputUrl": "https://spyne-prod-tech.s3.amazonaws.com/TaD1VC1Ko/eaabbf28/b0c88eea2f0e4afb8749155bd87977ef/2b6a21f3cd604158b6fc37f5f4e7ece9/images/input/hres_5n1dl1gs2nc335977_2b6a21f3cd604158b6fc37f5f4e7ece9_360_exterior_52_2b6a21f3cd604158b6fc37f5f4e7ece9_360_exterior_52.jpg",
            "outputUrl": "https://spyne-media.s3.amazonaws.com/2024-10-22/car_replace_bg_3516eec5-1052-4135-a0b6-6630dc18686e.jpg"
        },
        {
            "ai_angle": 160,
            "frame_seq_no": "53",
            "imageCategory": "360_exterior",
            "image_id": "img-416f29416eed47a3844882629599ace6",
            "inputUrl": "https://spyne-prod-tech.s3.amazonaws.com/TaD1VC1Ko/eaabbf28/b0c88eea2f0e4afb8749155bd87977ef/2b6a21f3cd604158b6fc37f5f4e7ece9/images/input/hres_5n1dl1gs2nc335977_2b6a21f3cd604158b6fc37f5f4e7ece9_360_exterior_53_2b6a21f3cd604158b6fc37f5f4e7ece9_360_exterior_53.jpg",
            "outputUrl": "https://spyne-media.s3.amazonaws.com/2024-10-22/car_replace_bg_eadd4911-3f03-4ca2-a7bb-3d93b8f431ca.jpg"
        },
        {
            "ai_angle": 170,
            "frame_seq_no": "54",
            "imageCategory": "360_exterior",
            "image_id": "img-2bd1b47a138e45cda39422622219544d",
            "inputUrl": "https://spyne-prod-tech.s3.amazonaws.com/TaD1VC1Ko/eaabbf28/b0c88eea2f0e4afb8749155bd87977ef/2b6a21f3cd604158b6fc37f5f4e7ece9/images/input/hres_5n1dl1gs2nc335977_2b6a21f3cd604158b6fc37f5f4e7ece9_360_exterior_54_2b6a21f3cd604158b6fc37f5f4e7ece9_360_exterior_54.jpg",
            "outputUrl": "https://spyne-media.s3.amazonaws.com/2024-10-22/car_replace_bg_672960cf-c4e4-4040-ac38-29dbf408a175.jpg"
        },
        {
            "ai_angle": 170,
            "frame_seq_no": "55",
            "imageCategory": "360_exterior",
            "image_id": "img-03bd830e5a3a4b12a3300a21c8537fff",
            "inputUrl": "https://spyne-prod-tech.s3.amazonaws.com/TaD1VC1Ko/eaabbf28/b0c88eea2f0e4afb8749155bd87977ef/2b6a21f3cd604158b6fc37f5f4e7ece9/images/input/hres_5n1dl1gs2nc335977_2b6a21f3cd604158b6fc37f5f4e7ece9_360_exterior_55_2b6a21f3cd604158b6fc37f5f4e7ece9_360_exterior_55.jpg",
            "outputUrl": "https://spyne-media.s3.amazonaws.com/2024-10-22/car_replace_bg_e44a2c92-1b83-4c0d-b7c4-a672d3199055.jpg"
        },
        {
            "ai_angle": 180,
            "frame_seq_no": "56",
            "imageCategory": "360_exterior",
            "image_id": "img-318e9c6da84549f4be8d53d4c6227882",
            "inputUrl": "https://spyne-prod-tech.s3.amazonaws.com/TaD1VC1Ko/eaabbf28/b0c88eea2f0e4afb8749155bd87977ef/2b6a21f3cd604158b6fc37f5f4e7ece9/images/input/hres_5n1dl1gs2nc335977_2b6a21f3cd604158b6fc37f5f4e7ece9_360_exterior_56_2b6a21f3cd604158b6fc37f5f4e7ece9_360_exterior_56.jpg",
            "outputUrl": "https://spyne-media.s3.amazonaws.com/2024-10-22/car_replace_bg_a2aa4d3a-92b0-4c54-a3e5-e7b138a50f55.jpg"
        },
        {
            "ai_angle": 180,
            "frame_seq_no": "57",
            "imageCategory": "360_exterior",
            "image_id": "img-9d9b4fd02b8e4959a2c8d3ee5d932732",
            "inputUrl": "https://spyne-prod-tech.s3.amazonaws.com/TaD1VC1Ko/eaabbf28/b0c88eea2f0e4afb8749155bd87977ef/2b6a21f3cd604158b6fc37f5f4e7ece9/images/input/hres_5n1dl1gs2nc335977_2b6a21f3cd604158b6fc37f5f4e7ece9_360_exterior_57_2b6a21f3cd604158b6fc37f5f4e7ece9_360_exterior_57.jpg",
            "outputUrl": "https://spyne-media.s3.amazonaws.com/2024-10-22/car_replace_bg_7dd37a1b-7fa9-4cf5-9684-f950cd482670.jpg"
        },
        {
            "ai_angle": 180,
            "frame_seq_no": "58",
            "imageCategory": "360_exterior",
            "image_id": "img-d1d5962bb30e41fd8109baf631491562",
            "inputUrl": "https://spyne-prod-tech.s3.amazonaws.com/TaD1VC1Ko/eaabbf28/b0c88eea2f0e4afb8749155bd87977ef/2b6a21f3cd604158b6fc37f5f4e7ece9/images/input/hres_5n1dl1gs2nc335977_2b6a21f3cd604158b6fc37f5f4e7ece9_360_exterior_58_2b6a21f3cd604158b6fc37f5f4e7ece9_360_exterior_58.jpg",
            "outputUrl": "https://spyne-media.s3.amazonaws.com/2024-10-22/car_replace_bg_0225b22c-4f6a-4d87-b18a-676ad8832945.jpg"
        },
        {
            "ai_angle": 180,
            "frame_seq_no": "59",
            "imageCategory": "360_exterior",
            "image_id": "img-72753618ed684380942f4790708cd101",
            "inputUrl": "https://spyne-prod-tech.s3.amazonaws.com/TaD1VC1Ko/eaabbf28/b0c88eea2f0e4afb8749155bd87977ef/2b6a21f3cd604158b6fc37f5f4e7ece9/images/input/hres_5n1dl1gs2nc335977_2b6a21f3cd604158b6fc37f5f4e7ece9_360_exterior_59_2b6a21f3cd604158b6fc37f5f4e7ece9_360_exterior_59.jpg",
            "outputUrl": "https://spyne-media.s3.amazonaws.com/2024-10-22/car_replace_bg_48acea33-e6b1-46f4-a5eb-36a09ffeea84.jpg"
        },
        {
            "ai_angle": 190,
            "frame_seq_no": "60",
            "imageCategory": "360_exterior",
            "image_id": "img-a2c2f3e8cc2f44dc834a0edc5b3dd09d",
            "inputUrl": "https://spyne-prod-tech.s3.amazonaws.com/TaD1VC1Ko/eaabbf28/b0c88eea2f0e4afb8749155bd87977ef/2b6a21f3cd604158b6fc37f5f4e7ece9/images/input/hres_5n1dl1gs2nc335977_2b6a21f3cd604158b6fc37f5f4e7ece9_360_exterior_60_2b6a21f3cd604158b6fc37f5f4e7ece9_360_exterior_60.jpg",
            "outputUrl": "https://spyne-media.s3.amazonaws.com/2024-10-22/car_replace_bg_b28421b6-a502-4d0f-bb6a-341965f46def.jpg"
        },
        {
            "ai_angle": 190,
            "frame_seq_no": "61",
            "imageCategory": "360_exterior",
            "image_id": "img-1262ffee3e144c22ad8a28e7154f93b3",
            "inputUrl": "https://spyne-prod-tech.s3.amazonaws.com/TaD1VC1Ko/eaabbf28/b0c88eea2f0e4afb8749155bd87977ef/2b6a21f3cd604158b6fc37f5f4e7ece9/images/input/hres_5n1dl1gs2nc335977_2b6a21f3cd604158b6fc37f5f4e7ece9_360_exterior_61_2b6a21f3cd604158b6fc37f5f4e7ece9_360_exterior_61.jpg",
            "outputUrl": "https://spyne-media.s3.amazonaws.com/2024-10-22/car_replace_bg_e616bed2-a4e6-4ba0-8a16-958be672027e.jpg"
        },
        {
            "ai_angle": 200,
            "frame_seq_no": "62",
            "imageCategory": "360_exterior",
            "image_id": "img-a955555744cb49e6865ecbb5eed5ec8d",
            "inputUrl": "https://spyne-prod-tech.s3.amazonaws.com/TaD1VC1Ko/eaabbf28/b0c88eea2f0e4afb8749155bd87977ef/2b6a21f3cd604158b6fc37f5f4e7ece9/images/input/hres_5n1dl1gs2nc335977_2b6a21f3cd604158b6fc37f5f4e7ece9_360_exterior_62_2b6a21f3cd604158b6fc37f5f4e7ece9_360_exterior_62.jpg",
            "outputUrl": "https://spyne-media.s3.amazonaws.com/2024-10-22/car_replace_bg_eea6f6db-2434-47d6-b461-a68b3b01a3a6.jpg"
        },
        {
            "ai_angle": 210,
            "frame_seq_no": "63",
            "imageCategory": "360_exterior",
            "image_id": "img-616b770e280f49299ef952bdc0399fb4",
            "inputUrl": "https://spyne-prod-tech.s3.amazonaws.com/TaD1VC1Ko/eaabbf28/b0c88eea2f0e4afb8749155bd87977ef/2b6a21f3cd604158b6fc37f5f4e7ece9/images/input/hres_5n1dl1gs2nc335977_2b6a21f3cd604158b6fc37f5f4e7ece9_360_exterior_63_2b6a21f3cd604158b6fc37f5f4e7ece9_360_exterior_63.jpg",
            "outputUrl": "https://spyne-media.s3.amazonaws.com/2024-10-22/car_replace_bg_3cab9620-6a6e-46d5-84f1-326fd8471114.jpg"
        },
        {
            "ai_angle": 210,
            "frame_seq_no": "64",
            "imageCategory": "360_exterior",
            "image_id": "img-f7d2cfa7d2804cd18bc7ecd126981198",
            "inputUrl": "https://spyne-prod-tech.s3.amazonaws.com/TaD1VC1Ko/eaabbf28/b0c88eea2f0e4afb8749155bd87977ef/2b6a21f3cd604158b6fc37f5f4e7ece9/images/input/hres_5n1dl1gs2nc335977_2b6a21f3cd604158b6fc37f5f4e7ece9_360_exterior_64_2b6a21f3cd604158b6fc37f5f4e7ece9_360_exterior_64.jpg",
            "outputUrl": "https://spyne-media.s3.amazonaws.com/2024-10-22/car_replace_bg_c1c49abb-5fea-4075-8adb-4cb566c55af7.jpg"
        },
        {
            "ai_angle": 210,
            "frame_seq_no": "65",
            "imageCategory": "360_exterior",
            "image_id": "img-f0322c9e46ff4eabae6f165785a405d6",
            "inputUrl": "https://spyne-prod-tech.s3.amazonaws.com/TaD1VC1Ko/eaabbf28/b0c88eea2f0e4afb8749155bd87977ef/2b6a21f3cd604158b6fc37f5f4e7ece9/images/input/hres_5n1dl1gs2nc335977_2b6a21f3cd604158b6fc37f5f4e7ece9_360_exterior_65_2b6a21f3cd604158b6fc37f5f4e7ece9_360_exterior_65.jpg",
            "outputUrl": "https://spyne-media.s3.amazonaws.com/2024-10-22/car_replace_bg_777bb43a-c46e-4ad4-b320-4dbb43fed679.jpg"
        },
        {
            "ai_angle": 210,
            "frame_seq_no": "66",
            "imageCategory": "360_exterior",
            "image_id": "img-72a78cbf2dda4a849c1735b35f87229f",
            "inputUrl": "https://spyne-prod-tech.s3.amazonaws.com/TaD1VC1Ko/eaabbf28/b0c88eea2f0e4afb8749155bd87977ef/2b6a21f3cd604158b6fc37f5f4e7ece9/images/input/hres_5n1dl1gs2nc335977_2b6a21f3cd604158b6fc37f5f4e7ece9_360_exterior_66_2b6a21f3cd604158b6fc37f5f4e7ece9_360_exterior_66.jpg",
            "outputUrl": "https://spyne-media.s3.amazonaws.com/2024-10-22/car_replace_bg_f5493b2d-7821-4c5e-8e6a-364b8332c688.jpg"
        },
        {
            "ai_angle": 220,
            "frame_seq_no": "67",
            "imageCategory": "360_exterior",
            "image_id": "img-be3a2c313cf6462a8e09621ba56a99f2",
            "inputUrl": "https://spyne-prod-tech.s3.amazonaws.com/TaD1VC1Ko/eaabbf28/b0c88eea2f0e4afb8749155bd87977ef/2b6a21f3cd604158b6fc37f5f4e7ece9/images/input/hres_5n1dl1gs2nc335977_2b6a21f3cd604158b6fc37f5f4e7ece9_360_exterior_67_2b6a21f3cd604158b6fc37f5f4e7ece9_360_exterior_67.jpg",
            "outputUrl": "https://spyne-media.s3.amazonaws.com/2024-10-22/car_replace_bg_01500789-8f21-4fa2-bb2a-d6c951c951bd.jpg"
        },
        {
            "ai_angle": 220,
            "frame_seq_no": "68",
            "imageCategory": "360_exterior",
            "image_id": "img-f7453dce374d4ba48061ab7676de8fde",
            "inputUrl": "https://spyne-prod-tech.s3.amazonaws.com/TaD1VC1Ko/eaabbf28/b0c88eea2f0e4afb8749155bd87977ef/2b6a21f3cd604158b6fc37f5f4e7ece9/images/input/hres_5n1dl1gs2nc335977_2b6a21f3cd604158b6fc37f5f4e7ece9_360_exterior_68_2b6a21f3cd604158b6fc37f5f4e7ece9_360_exterior_68.jpg",
            "outputUrl": "https://spyne-media.s3.amazonaws.com/2024-10-22/car_replace_bg_05b4ff67-2e97-42c2-b86d-f9cc291265c3.jpg"
        },
        {
            "ai_angle": 230,
            "frame_seq_no": "69",
            "imageCategory": "360_exterior",
            "image_id": "img-db4ca642c9194e7ea21f507fe4f4d57a",
            "inputUrl": "https://spyne-prod-tech.s3.amazonaws.com/TaD1VC1Ko/eaabbf28/b0c88eea2f0e4afb8749155bd87977ef/2b6a21f3cd604158b6fc37f5f4e7ece9/images/input/hres_5n1dl1gs2nc335977_2b6a21f3cd604158b6fc37f5f4e7ece9_360_exterior_69_2b6a21f3cd604158b6fc37f5f4e7ece9_360_exterior_69.jpg",
            "outputUrl": "https://spyne-media.s3.amazonaws.com/2024-10-22/car_replace_bg_00d8a84b-0dee-4404-807e-d650cd84a719.jpg"
        },
        {
            "ai_angle": 230,
            "frame_seq_no": "70",
            "imageCategory": "360_exterior",
            "image_id": "img-c15bcca921c341cd9f53ed81dd276e20",
            "inputUrl": "https://spyne-prod-tech.s3.amazonaws.com/TaD1VC1Ko/eaabbf28/b0c88eea2f0e4afb8749155bd87977ef/2b6a21f3cd604158b6fc37f5f4e7ece9/images/input/hres_5n1dl1gs2nc335977_2b6a21f3cd604158b6fc37f5f4e7ece9_360_exterior_70_2b6a21f3cd604158b6fc37f5f4e7ece9_360_exterior_70.jpg",
            "outputUrl": "https://spyne-media.s3.amazonaws.com/2024-10-22/car_replace_bg_02787829-b3ce-4287-9471-c7362bfab6d2.jpg"
        },
        {
            "ai_angle": 240,
            "frame_seq_no": "71",
            "imageCategory": "360_exterior",
            "image_id": "img-b849ab83d51b46a1a78a533f36c93d92",
            "inputUrl": "https://spyne-prod-tech.s3.amazonaws.com/TaD1VC1Ko/eaabbf28/b0c88eea2f0e4afb8749155bd87977ef/2b6a21f3cd604158b6fc37f5f4e7ece9/images/input/hres_5n1dl1gs2nc335977_2b6a21f3cd604158b6fc37f5f4e7ece9_360_exterior_71_2b6a21f3cd604158b6fc37f5f4e7ece9_360_exterior_71.jpg",
            "outputUrl": "https://spyne-media.s3.amazonaws.com/2024-10-22/car_replace_bg_511c38f2-7100-4ef6-989a-5eb2806c64dd.jpg"
        },
        {
            "ai_angle": 240,
            "frame_seq_no": "72",
            "imageCategory": "360_exterior",
            "image_id": "img-44bdf1aa7ca745cbb8c0b5b84a022381",
            "inputUrl": "https://spyne-prod-tech.s3.amazonaws.com/TaD1VC1Ko/eaabbf28/b0c88eea2f0e4afb8749155bd87977ef/2b6a21f3cd604158b6fc37f5f4e7ece9/images/input/hres_5n1dl1gs2nc335977_2b6a21f3cd604158b6fc37f5f4e7ece9_360_exterior_72_2b6a21f3cd604158b6fc37f5f4e7ece9_360_exterior_72.jpg",
            "outputUrl": "https://spyne-media.s3.amazonaws.com/2024-10-22/car_replace_bg_27a92e1b-bd09-4fc7-84db-c86bfd6c0ff6.jpg"
        },
        {
            "ai_angle": 240,
            "frame_seq_no": "73",
            "imageCategory": "360_exterior",
            "image_id": "img-10906d8934434fa0a4010f78601542d4",
            "inputUrl": "https://spyne-prod-tech.s3.amazonaws.com/TaD1VC1Ko/eaabbf28/b0c88eea2f0e4afb8749155bd87977ef/2b6a21f3cd604158b6fc37f5f4e7ece9/images/input/hres_5n1dl1gs2nc335977_2b6a21f3cd604158b6fc37f5f4e7ece9_360_exterior_73_2b6a21f3cd604158b6fc37f5f4e7ece9_360_exterior_73.jpg",
            "outputUrl": "https://spyne-media.s3.amazonaws.com/2024-10-22/car_replace_bg_a3ec27ab-a0fc-4e7b-936b-b1012e71906a.jpg"
        },
        {
            "ai_angle": 250,
            "frame_seq_no": "74",
            "imageCategory": "360_exterior",
            "image_id": "img-7eb01b54651740e8ba61ebe218c85a7c",
            "inputUrl": "https://spyne-prod-tech.s3.amazonaws.com/TaD1VC1Ko/eaabbf28/b0c88eea2f0e4afb8749155bd87977ef/2b6a21f3cd604158b6fc37f5f4e7ece9/images/input/hres_5n1dl1gs2nc335977_2b6a21f3cd604158b6fc37f5f4e7ece9_360_exterior_74_2b6a21f3cd604158b6fc37f5f4e7ece9_360_exterior_74.jpg",
            "outputUrl": "https://spyne-media.s3.amazonaws.com/2024-10-22/car_replace_bg_47bd8e69-af3c-4009-90f9-f0f088b5f8fc.jpg"
        },
        {
            "ai_angle": 250,
            "frame_seq_no": "75",
            "imageCategory": "360_exterior",
            "image_id": "img-c0ac7d7175f04ccf9aa683cbde2dc20d",
            "inputUrl": "https://spyne-prod-tech.s3.amazonaws.com/TaD1VC1Ko/eaabbf28/b0c88eea2f0e4afb8749155bd87977ef/2b6a21f3cd604158b6fc37f5f4e7ece9/images/input/hres_5n1dl1gs2nc335977_2b6a21f3cd604158b6fc37f5f4e7ece9_360_exterior_75_2b6a21f3cd604158b6fc37f5f4e7ece9_360_exterior_75.jpg",
            "outputUrl": "https://spyne-media.s3.amazonaws.com/2024-10-22/car_replace_bg_3864a999-36be-4925-b51c-c91521007091.jpg"
        },
        {
            "ai_angle": 250,
            "frame_seq_no": "76",
            "imageCategory": "360_exterior",
            "image_id": "img-77b3a2029b4f4a5798978d9c430797ac",
            "inputUrl": "https://spyne-prod-tech.s3.amazonaws.com/TaD1VC1Ko/eaabbf28/b0c88eea2f0e4afb8749155bd87977ef/2b6a21f3cd604158b6fc37f5f4e7ece9/images/input/hres_5n1dl1gs2nc335977_2b6a21f3cd604158b6fc37f5f4e7ece9_360_exterior_76_2b6a21f3cd604158b6fc37f5f4e7ece9_360_exterior_76.jpg",
            "outputUrl": "https://spyne-media.s3.amazonaws.com/2024-10-22/car_replace_bg_2dd702d4-eba7-46a2-ac1d-16ffbe34f692.jpg"
        },
        {
            "ai_angle": 260,
            "frame_seq_no": "77",
            "imageCategory": "360_exterior",
            "image_id": "img-ca6d4db115584dc28baaf53d1cc2d6d1",
            "inputUrl": "https://spyne-prod-tech.s3.amazonaws.com/TaD1VC1Ko/eaabbf28/b0c88eea2f0e4afb8749155bd87977ef/2b6a21f3cd604158b6fc37f5f4e7ece9/images/input/hres_5n1dl1gs2nc335977_2b6a21f3cd604158b6fc37f5f4e7ece9_360_exterior_77_2b6a21f3cd604158b6fc37f5f4e7ece9_360_exterior_77.jpg",
            "outputUrl": "https://spyne-media.s3.amazonaws.com/2024-10-22/car_replace_bg_d7d536d6-e576-4ab8-950e-4774a1487638.jpg"
        },
        {
            "ai_angle": 260,
            "frame_seq_no": "78",
            "imageCategory": "360_exterior",
            "image_id": "img-dbf2908db60d4d9daa9428fbd9e8b38f",
            "inputUrl": "https://spyne-prod-tech.s3.amazonaws.com/TaD1VC1Ko/eaabbf28/b0c88eea2f0e4afb8749155bd87977ef/2b6a21f3cd604158b6fc37f5f4e7ece9/images/input/hres_5n1dl1gs2nc335977_2b6a21f3cd604158b6fc37f5f4e7ece9_360_exterior_78_2b6a21f3cd604158b6fc37f5f4e7ece9_360_exterior_78.jpg",
            "outputUrl": "https://spyne-media.s3.amazonaws.com/2024-10-22/car_replace_bg_3cef65fc-36cc-414d-ae9a-8dfa3b38f39e.jpg"
        },
        {
            "ai_angle": 260,
            "frame_seq_no": "79",
            "imageCategory": "360_exterior",
            "image_id": "img-21d8fa9218664d64b5f8edd3b18b8b2d",
            "inputUrl": "https://spyne-prod-tech.s3.amazonaws.com/TaD1VC1Ko/eaabbf28/b0c88eea2f0e4afb8749155bd87977ef/2b6a21f3cd604158b6fc37f5f4e7ece9/images/input/hres_5n1dl1gs2nc335977_2b6a21f3cd604158b6fc37f5f4e7ece9_360_exterior_79_2b6a21f3cd604158b6fc37f5f4e7ece9_360_exterior_79.jpg",
            "outputUrl": "https://spyne-media.s3.amazonaws.com/2024-10-22/car_replace_bg_325550f9-1693-4e67-bdd4-975ab595099d.jpg"
        },
        {
            "ai_angle": 270,
            "frame_seq_no": "80",
            "imageCategory": "360_exterior",
            "image_id": "img-77696919b5bc4679b9dd8788c2d57824",
            "inputUrl": "https://spyne-prod-tech.s3.amazonaws.com/TaD1VC1Ko/eaabbf28/b0c88eea2f0e4afb8749155bd87977ef/2b6a21f3cd604158b6fc37f5f4e7ece9/images/input/hres_5n1dl1gs2nc335977_2b6a21f3cd604158b6fc37f5f4e7ece9_360_exterior_80_2b6a21f3cd604158b6fc37f5f4e7ece9_360_exterior_80.jpg",
            "outputUrl": "https://spyne-media.s3.amazonaws.com/2024-10-22/car_replace_bg_ff4646de-3749-4795-b9f8-200e0ee9f2cc.jpg"
        },
        {
            "ai_angle": 270,
            "frame_seq_no": "81",
            "imageCategory": "360_exterior",
            "image_id": "img-d46cf17edd7d49f1ad258afca798430c",
            "inputUrl": "https://spyne-prod-tech.s3.amazonaws.com/TaD1VC1Ko/eaabbf28/b0c88eea2f0e4afb8749155bd87977ef/2b6a21f3cd604158b6fc37f5f4e7ece9/images/input/hres_5n1dl1gs2nc335977_2b6a21f3cd604158b6fc37f5f4e7ece9_360_exterior_81_2b6a21f3cd604158b6fc37f5f4e7ece9_360_exterior_81.jpg",
            "outputUrl": "https://spyne-media.s3.amazonaws.com/2024-10-22/car_replace_bg_d9525172-ff38-4986-aa9a-09f960076164.jpg"
        },
        {
            "ai_angle": 280,
            "frame_seq_no": "82",
            "imageCategory": "360_exterior",
            "image_id": "img-60db7813cdc94935ab85cf9328c97fe5",
            "inputUrl": "https://spyne-prod-tech.s3.amazonaws.com/TaD1VC1Ko/eaabbf28/b0c88eea2f0e4afb8749155bd87977ef/2b6a21f3cd604158b6fc37f5f4e7ece9/images/input/hres_5n1dl1gs2nc335977_2b6a21f3cd604158b6fc37f5f4e7ece9_360_exterior_82_2b6a21f3cd604158b6fc37f5f4e7ece9_360_exterior_82.jpg",
            "outputUrl": "https://spyne-media.s3.amazonaws.com/2024-10-22/car_replace_bg_5cf82459-f3c6-4b7a-b19a-c3e617f84284.jpg"
        },
        {
            "ai_angle": 280,
            "frame_seq_no": "83",
            "imageCategory": "360_exterior",
            "image_id": "img-487587592691412ab5ec481e9283884c",
            "inputUrl": "https://spyne-prod-tech.s3.amazonaws.com/TaD1VC1Ko/eaabbf28/b0c88eea2f0e4afb8749155bd87977ef/2b6a21f3cd604158b6fc37f5f4e7ece9/images/input/hres_5n1dl1gs2nc335977_2b6a21f3cd604158b6fc37f5f4e7ece9_360_exterior_83_2b6a21f3cd604158b6fc37f5f4e7ece9_360_exterior_83.jpg",
            "outputUrl": "https://spyne-media.s3.amazonaws.com/2024-10-22/car_replace_bg_9f97db34-e4f8-4e68-8515-4239cc6961b7.jpg"
        },
        {
            "ai_angle": 290,
            "frame_seq_no": "84",
            "imageCategory": "360_exterior",
            "image_id": "img-671ee2e94a014b6aa1b6ad5d0dffce37",
            "inputUrl": "https://spyne-prod-tech.s3.amazonaws.com/TaD1VC1Ko/eaabbf28/b0c88eea2f0e4afb8749155bd87977ef/2b6a21f3cd604158b6fc37f5f4e7ece9/images/input/hres_5n1dl1gs2nc335977_2b6a21f3cd604158b6fc37f5f4e7ece9_360_exterior_84_2b6a21f3cd604158b6fc37f5f4e7ece9_360_exterior_84.jpg",
            "outputUrl": "https://spyne-media.s3.amazonaws.com/2024-10-22/car_replace_bg_7c77a7eb-ba6b-4260-b3d0-dbc0dd66977a.jpg"
        },
        {
            "ai_angle": 290,
            "frame_seq_no": "85",
            "imageCategory": "360_exterior",
            "image_id": "img-0e11af9d6b8048beb18149eb133bbd06",
            "inputUrl": "https://spyne-prod-tech.s3.amazonaws.com/TaD1VC1Ko/eaabbf28/b0c88eea2f0e4afb8749155bd87977ef/2b6a21f3cd604158b6fc37f5f4e7ece9/images/input/hres_5n1dl1gs2nc335977_2b6a21f3cd604158b6fc37f5f4e7ece9_360_exterior_85_2b6a21f3cd604158b6fc37f5f4e7ece9_360_exterior_85.jpg",
            "outputUrl": "https://spyne-media.s3.amazonaws.com/2024-10-22/car_replace_bg_24da01cc-12f1-4d4f-aee8-60bbcd7fc8cd.jpg"
        },
        {
            "ai_angle": 290,
            "frame_seq_no": "86",
            "imageCategory": "360_exterior",
            "image_id": "img-ccf2a80ffb8e4103921852308b86bde5",
            "inputUrl": "https://spyne-prod-tech.s3.amazonaws.com/TaD1VC1Ko/eaabbf28/b0c88eea2f0e4afb8749155bd87977ef/2b6a21f3cd604158b6fc37f5f4e7ece9/images/input/hres_5n1dl1gs2nc335977_2b6a21f3cd604158b6fc37f5f4e7ece9_360_exterior_86_2b6a21f3cd604158b6fc37f5f4e7ece9_360_exterior_86.jpg",
            "outputUrl": "https://spyne-media.s3.amazonaws.com/2024-10-22/car_replace_bg_2d1745a6-ea80-4327-9cc6-d5c191d65cbc.jpg"
        },
        {
            "ai_angle": 300,
            "frame_seq_no": "87",
            "imageCategory": "360_exterior",
            "image_id": "img-f9b7f97b5581429fbd963bbd0f093b59",
            "inputUrl": "https://spyne-prod-tech.s3.amazonaws.com/TaD1VC1Ko/eaabbf28/b0c88eea2f0e4afb8749155bd87977ef/2b6a21f3cd604158b6fc37f5f4e7ece9/images/input/hres_5n1dl1gs2nc335977_2b6a21f3cd604158b6fc37f5f4e7ece9_360_exterior_87_2b6a21f3cd604158b6fc37f5f4e7ece9_360_exterior_87.jpg",
            "outputUrl": "https://spyne-media.s3.amazonaws.com/2024-10-22/car_replace_bg_9c8be4e2-12ef-4da2-b0b0-a06244926f62.jpg"
        },
        {
            "ai_angle": 300,
            "frame_seq_no": "88",
            "imageCategory": "360_exterior",
            "image_id": "img-2207da6ce1304a838848c3c0e46fee2d",
            "inputUrl": "https://spyne-prod-tech.s3.amazonaws.com/TaD1VC1Ko/eaabbf28/b0c88eea2f0e4afb8749155bd87977ef/2b6a21f3cd604158b6fc37f5f4e7ece9/images/input/hres_5n1dl1gs2nc335977_2b6a21f3cd604158b6fc37f5f4e7ece9_360_exterior_88_2b6a21f3cd604158b6fc37f5f4e7ece9_360_exterior_88.jpg",
            "outputUrl": "https://spyne-media.s3.amazonaws.com/2024-10-22/car_replace_bg_e0f9455a-887f-462d-870c-da982c1c92c7.jpg"
        },
        {
            "ai_angle": 300,
            "frame_seq_no": "89",
            "imageCategory": "360_exterior",
            "image_id": "img-be5891a030064432b56024470216d880",
            "inputUrl": "https://spyne-prod-tech.s3.amazonaws.com/TaD1VC1Ko/eaabbf28/b0c88eea2f0e4afb8749155bd87977ef/2b6a21f3cd604158b6fc37f5f4e7ece9/images/input/hres_5n1dl1gs2nc335977_2b6a21f3cd604158b6fc37f5f4e7ece9_360_exterior_89_2b6a21f3cd604158b6fc37f5f4e7ece9_360_exterior_89.jpg",
            "outputUrl": "https://spyne-media.s3.amazonaws.com/2024-10-22/car_replace_bg_889c9983-4c0d-4634-9c42-8565dc41b31f.jpg"
        },
        {
            "ai_angle": 310,
            "frame_seq_no": "90",
            "imageCategory": "360_exterior",
            "image_id": "img-fbdee4af9e4d4a5a880f4eaa7af911ca",
            "inputUrl": "https://spyne-prod-tech.s3.amazonaws.com/TaD1VC1Ko/eaabbf28/b0c88eea2f0e4afb8749155bd87977ef/2b6a21f3cd604158b6fc37f5f4e7ece9/images/input/hres_5n1dl1gs2nc335977_2b6a21f3cd604158b6fc37f5f4e7ece9_360_exterior_90_2b6a21f3cd604158b6fc37f5f4e7ece9_360_exterior_90.jpg",
            "outputUrl": "https://spyne-media.s3.amazonaws.com/2024-10-22/car_replace_bg_7f48d03e-c248-4579-86ee-4d27ece3b51f.jpg"
        }
    ],
    "engineTransmission": {
        "engine": {
            "value": "3.5L V6 DOHC 24V",
            "title": "Engine",
            "icon": "https://spyne-static.s3.amazonaws.com/console/inventoryDetails/vehicleInfo/engineAndTransmission/engine.svg"
        },
        "driveline": {
            "value": "AWD",
            "title": "Wheel Drive",
            "icon": "https://spyne-static.s3.amazonaws.com/console/inventory/vehicleInfo/vehicleSnapshot/driveline.svg"
        },
        "antiBrakeSystem": {
            "value": "4-Wheel ABS",
            "title": "Anti Brake System",
            "icon": "https://spyne-static.s3.amazonaws.com/console/inventoryDetails/vehicleInfo/engineAndTransmission/anti_brake_system.svg"
        },
        "transmissionLong": {
            "value": "Continuously Variable Transmission",
            "title": "Transmission Long",
            "icon": "https://spyne-static.s3.amazonaws.com/console/inventoryDetails/vehicleInfo/engineAndTransmission/transmission_long.svg"
        },
        "fuelTank": {
            "value": "19.50 gallon",
            "title": "Tank Size",
            "icon": "https://spyne-static.s3.amazonaws.com/console/inventoryDetails/vehicleInfo/engineAndTransmission/tank_size.svg"
        },
        "highwayMileage": {
            "value": "25 miles/gallon",
            "title": "Highway Mileage",
            "icon": "https://spyne-static.s3.amazonaws.com/console/inventoryDetails/vehicleInfo/engineAndTransmission/highwayMileage.svg"
        },
        "cityMileage": {
            "value": "20 miles/gallon",
            "title": "City Mileage",
            "icon": "https://spyne-static.s3.amazonaws.com/console/inventoryDetails/vehicleInfo/engineAndTransmission/city_mileage.svg"
        },
        "maximumGvwr": {
            "value": "",
            "title": "Maximum GVWR",
            "icon": "https://spyne-static.s3.amazonaws.com/console/inventoryDetails/vehicleInfo/engineAndTransmission/maximum_gvwr.svg"
        }
    },
    "featureSnap": {
        "separateDriverFrontPassengerClimateControls": {
            "value": true,
            "title": "Climate Control",
            "icon": "https://spyne-static.s3.amazonaws.com/console/inventory/vehicleInfo/Checkbox.svg"
        },
        "cruiseControl": {
            "value": true,
            "title": "Cruise Control",
            "icon": "https://spyne-static.s3.amazonaws.com/console/inventory/vehicleInfo/Checkbox.svg"
        },
        "frontCooledSeat": {
            "value": false,
            "title": "Front Cooled Seat",
            "icon": "https://spyne-static.s3.amazonaws.com/console/inventory/vehicleInfo/Checkbox.svg"
        },
        "frontHeatedSeat": {
            "value": true,
            "title": "Front Heated Seat",
            "icon": "https://spyne-static.s3.amazonaws.com/console/inventory/vehicleInfo/Checkbox.svg"
        },
        "heatedSteeringWheel": {
            "value": true,
            "title": "Heated Steering Wheel",
            "icon": "https://spyne-static.s3.amazonaws.com/console/inventory/vehicleInfo/Checkbox.svg"
        },
        "leatherSteeringWheel": {
            "value": true,
            "title": "Leather Steering Wheel",
            "icon": "https://spyne-static.s3.amazonaws.com/console/inventory/vehicleInfo/Checkbox.svg"
        },
        "powerTrunkLid": {
            "value": false,
            "title": "Power Trunk Lid",
            "icon": "https://spyne-static.s3.amazonaws.com/console/inventory/vehicleInfo/Checkbox.svg"
        },
        "tyrePressureMonitor": {
            "value": true,
            "title": "Tyre Pressure Monitor",
            "icon": "https://spyne-static.s3.amazonaws.com/console/inventory/vehicleInfo/Checkbox.svg"
        },
        "cdPlayer": {
            "value": false,
            "title": "CD Player",
            "icon": "https://spyne-static.s3.amazonaws.com/console/inventory/vehicleInfo/Checkbox.svg"
        },
        "airConditioning": {
            "value": true,
            "title": "Air Conditioning",
            "icon": "https://spyne-static.s3.amazonaws.com/console/inventory/vehicleInfo/Checkbox.svg"
        },
        "leatherSeat": {
            "value": true,
            "title": "Leather Seat",
            "icon": "https://spyne-static.s3.amazonaws.com/console/inventory/vehicleInfo/Checkbox.svg"
        },
        "driverMultiAdjustablePowerSeat": {
            "value": true,
            "title": "Multi Adjustable Power Seat",
            "icon": "https://spyne-static.s3.amazonaws.com/console/inventory/vehicleInfo/Checkbox.svg"
        },
        "tiltSteering": {
            "value": true,
            "title": "Tilt Steering",
            "icon": "https://spyne-static.s3.amazonaws.com/console/inventory/vehicleInfo/Checkbox.svg"
        },
        "remoteIgnition": {
            "value": true,
            "title": "Remote Ignition",
            "icon": "https://spyne-static.s3.amazonaws.com/console/inventory/vehicleInfo/Checkbox.svg"
        },
        "navigationAid": {
            "value": false,
            "title": "Navigation Aid",
            "icon": "https://spyne-static.s3.amazonaws.com/console/inventory/vehicleInfo/Checkbox.svg"
        },
        "amFmRadio": {
            "value": true,
            "title": "AM/FM Radio",
            "icon": "https://spyne-static.s3.amazonaws.com/console/inventory/vehicleInfo/Checkbox.svg"
        },
        "voiceActivatedTelephone": {
            "value": false,
            "title": "Voice Activated Telephone",
            "icon": "https://spyne-static.s3.amazonaws.com/console/inventory/vehicleInfo/Checkbox.svg"
        }
    },
    "interiorExteriorDetails": {
        "standardSeating": {
            "value": "7",
            "title": "Standard Seating",
            "icon": "https://spyne-static.s3.amazonaws.com/console/inventoryDetails/vehicleInfo/interiorAndExteriorDetails/standard_seating.svg"
        },
        "frontHipRoom": {
            "value": "58.80 in.",
            "title": "Front Hip Room"
        },
        "rearHipRoom": {
            "value": "56.70 in.",
            "title": "Rear Hip Room",
            "icon": "https://spyne-static.s3.amazonaws.com/console/inventoryDetails/vehicleInfo/interiorAndExteriorDetails/rear_hip_room.svg"
        },
        "powerSunroof": {
            "value": "N/A",
            "title": "Power Sunroof",
            "icon": "https://spyne-static.s3.amazonaws.com/console/inventoryDetails/vehicleInfo/interiorAndExteriorDetails/power_sunroof.svg"
        },
        "tyre": {
            "value": "255/50R20",
            "title": "Tyre",
            "icon": "https://spyne-static.s3.amazonaws.com/console/inventoryDetails/vehicleInfo/interiorAndExteriorDetails/type.svg"
        },
        "alloyWheels": {
            "value": "Std.",
            "title": "Alloy Wheels",
            "icon": "https://spyne-static.s3.amazonaws.com/console/inventoryDetails/vehicleInfo/interiorAndExteriorDetails/alloy_wheels.svg"
        },
        "chromeWheels": {
            "value": "N/A",
            "title": "Chrome Wheels",
            "icon": "https://spyne-static.s3.amazonaws.com/console/inventoryDetails/vehicleInfo/interiorAndExteriorDetails/chrome_wheels.svg"
        },
        "length": {
            "value": "198.20 in.",
            "title": "Length",
            "icon": "https://spyne-static.s3.amazonaws.com/console/inventoryDetails/vehicleInfo/interiorAndExteriorDetails/length.svg"
        },
        "width": {
            "value": "",
            "title": "Width"
        },
        "height": {
            "value": "",
            "title": "Height"
        },
        "wheelbase": {
            "value": "114.20 in.",
            "title": "Wheel base",
            "icon": "https://spyne-static.s3.amazonaws.com/console/inventoryDetails/vehicleInfo/interiorAndExteriorDetails/wheel_base.svg"
        }
    },
    "vehicleSnap": {
        "exteriorColor": {
            "value": [
                "Majestic White ",
                " Graphite Shadow ",
                " Warm Titanium ",
                " Grand Blue ",
                " MoonBow Blue ",
                " Deep Bordeaux ",
                " Mineral Black ",
                " Mocha Almond"
            ],
            "title": "Exterior Color",
            "required": false,
            "position": 6,
            "icon": "https://spyne-static.s3.amazonaws.com/console/inventoryDetails/vehicleInfo/vehicleSnap/exterior_color.svg"
        },
        "interiorTrim": {
            "value": [
                "Graphite ",
                " Saddle ",
                " Sand Stone"
            ],
            "title": "Interior Trim",
            "required": false,
            "position": 12,
            "icon": "https://spyne-static.s3.amazonaws.com/console/inventoryDetails/vehicleInfo/vehicleSnap/interior_trim.svg"
        },
        "mileage": {
            "value": "",
            "title": "Mileage",
            "required": false,
            "position": 13,
            "icon": "https://spyne-static.s3.amazonaws.com/console/inventoryDetails/vehicleInfo/vehicleSnap/mileage.svg"
        },
        "transmissionShort": {
            "value": "CVT",
            "title": "Transmission Short",
            "required": false,
            "position": 14,
            "icon": "https://spyne-static.s3.amazonaws.com/console/inventoryDetails/vehicleInfo/vehicleSnap/transmission_short.svg"
        },
        "engine": {
            "value": "3.5L V6 DOHC 24V",
            "title": "Engine",
            "required": false,
            "position": 11,
            "icon": "https://spyne-static.s3.amazonaws.com/console/inventoryDetails/vehicleInfo/vehicleSnap/engine.svg"
        },
        "trim": {
            "value": "Sensory AWD",
            "title": "Trim",
            "required": true,
            "position": 5,
            "icon": "https://spyne-static.s3.amazonaws.com/console/inventoryDetails/vehicleInfo/vehicleSnap/trim.svg"
        },
        "driveline": {
            "value": "AWD",
            "title": "Driveline",
            "required": false,
            "position": 1,
            "icon": "https://spyne-static.s3.amazonaws.com/console/inventoryDetails/vehicleInfo/vehicleSnap/driveline.svg"
        },
        "fuel": {
            "value": "",
            "title": "Fuel",
            "required": false,
            "position": 16,
            "icon": "https://spyne-static.s3.amazonaws.com/console/inventoryDetails/vehicleInfo/vehicleSnap/fuel.svg"
        },
        "condition": {
            "value": "used",
            "title": "Condition",
            "required": false,
            "position": 9,
            "icon": "https://spyne-static.s3.amazonaws.com/console/inventoryDetails/vehicleInfo/vehicleSnap/condition.svg"
        },
        "style": {
            "value": "CROSSOVER 4-DR",
            "title": "Style",
            "position": 10,
            "icon": "https://spyne-static.s3.amazonaws.com/console/inventoryDetails/vehicleInfo/vehicleSnap/style.svg"
        },
        "year": {
            "value": "2022",
            "title": "Year",
            "required": true,
            "position": 7,
            "icon": "https://spyne-static.s3.amazonaws.com/console/inventoryDetails/vehicleInfo/vehicleSnap/year.svg"
        },
        "msrp": {
            "value": 59375,
            "title": "Price",
            "currency": "USD",
            "sign": "$",
            "required": true,
            "position": 8,
            "icon": "https://spyne-static.s3.amazonaws.com/console/inventoryDetails/vehicleInfo/vehicleSnap/price.svg"
        },
        "make": {
            "value": "Infiniti",
            "title": "Make",
            "required": true,
            "position": 3,
            "icon": "https://spyne-static.s3.amazonaws.com/console/inventoryDetails/vehicleInfo/vehicleSnap/make.svg"
        },
        "model": {
            "value": "QX60",
            "title": "Model",
            "required": true,
            "position": 4,
            "icon": "https://spyne-static.s3.amazonaws.com/console/inventoryDetails/vehicleInfo/vehicleSnap/model.svg"
        },
        "vin": {
            "value": "5n1dl1gs2nc335977",
            "title": "VIN",
            "required": true,
            "position": 1
        },
        "stock": {
            "value": "",
            "title": "Stock#",
            "required": false,
            "position": 2,
            "icon": "https://spyne-static.s3.amazonaws.com/console/inventoryDetails/vehicleInfo/vehicleSnap/stock.svg"
        },
        "description": {
            "value": "",
            "title": "Description",
            "required": false,
            "position": 17,
            "icon": "https://spyne-static.s3.amazonaws.com/console/inventoryDetails/vehicleInfo/vehicleSnap/description.svg"
        },
        "vinUrl": {
            "value": "",
            "title": "Enter Website URL",
            "required": false,
            "position": 18
        }
    },
    "safetyDetails": {
        "driverAirbag": {
            "value": true,
            "title": "Driver Airbag",
            "icon": "https://spyne-static.s3.amazonaws.com/console/inventory/vehicleInfo/Checkbox.svg"
        },
        "passengerAirbag": {
            "value": true,
            "title": "Passenger Airbag",
            "icon": "https://spyne-static.s3.amazonaws.com/console/inventory/vehicleInfo/Checkbox.svg"
        },
        "frontSideAirbag": {
            "value": true,
            "title": "Front Side Airbag",
            "icon": "https://spyne-static.s3.amazonaws.com/console/inventory/vehicleInfo/Checkbox.svg"
        },
        "sideHeadCurtainAirbag": {
            "value": false,
            "title": "Side Head Curtain Airbag",
            "icon": "https://spyne-static.s3.amazonaws.com/console/inventory/vehicleInfo/Checkbox.svg"
        },
        "secondRowSideAirbag": {
            "value": false,
            "title": "Second Row Side Airbag",
            "icon": "https://spyne-static.s3.amazonaws.com/console/inventory/vehicleInfo/Checkbox.svg"
        },
        "vehicleStabilityControlSystem": {
            "value": true,
            "title": "Vehicle Stability Control System",
            "icon": "https://spyne-static.s3.amazonaws.com/console/inventory/vehicleInfo/Checkbox.svg"
        },
        "electronicParkingAid": {
            "value": true,
            "title": "Electronic Parking Aid",
            "icon": "https://spyne-static.s3.amazonaws.com/console/inventory/vehicleInfo/Checkbox.svg"
        },
        "electronicBrakeAssistance": {
            "value": true,
            "title": "Electronic Brake Assistance",
            "icon": "https://spyne-static.s3.amazonaws.com/console/inventory/vehicleInfo/Checkbox.svg"
        },
        "powerDoorLocks": {
            "value": true,
            "title": "Power Door Locks",
            "icon": "https://spyne-static.s3.amazonaws.com/console/inventory/vehicleInfo/Checkbox.svg"
        },
        "childSafetyDoorLocks": {
            "value": true,
            "title": "Child Safety Door Locks",
            "icon": "https://spyne-static.s3.amazonaws.com/console/inventory/vehicleInfo/Checkbox.svg"
        },
        "vehicleAntiTheft": {
            "value": true,
            "title": "Vehicle Anti Theft",
            "icon": "https://spyne-static.s3.amazonaws.com/console/inventory/vehicleInfo/Checkbox.svg"
        },
        "trunkAntiTrapDevice": {
            "value": false,
            "title": "Trunk Anti Trap Device",
            "icon": "https://spyne-static.s3.amazonaws.com/console/inventory/vehicleInfo/Checkbox.svg"
        },
        "automaticHeadlights": {
            "value": true,
            "title": "Automatic Headlights",
            "icon": "https://spyne-static.s3.amazonaws.com/console/inventory/vehicleInfo/Checkbox.svg"
        },
        "fogLights": {
            "value": false,
            "title": "Fog Lights",
            "icon": "https://spyne-static.s3.amazonaws.com/console/inventory/vehicleInfo/Checkbox.svg"
        }
    },
    "basicInfo": {
        "make": {
            "value": "Infiniti",
            "title": "Make",
            "required": true,
            "position": 3,
            "icon": "https://spyne-static.s3.amazonaws.com/console/inventoryDetails/vehicleInfo/vehicleSnap/make.svg"
        },
        "model": {
            "value": "QX60",
            "title": "Model",
            "required": true,
            "position": 4,
            "icon": "https://spyne-static.s3.amazonaws.com/console/inventoryDetails/vehicleInfo/vehicleSnap/model.svg"
        },
        "year": {
            "value": "2022",
            "title": "Year",
            "required": true,
            "position": 7,
            "icon": "https://spyne-static.s3.amazonaws.com/console/inventoryDetails/vehicleInfo/vehicleSnap/year.svg"
        },
        "msrp": {
            "value": 59375,
            "title": "Price",
            "currency": "USD",
            "sign": "$",
            "required": true,
            "position": 8,
            "icon": "https://spyne-static.s3.amazonaws.com/console/inventoryDetails/vehicleInfo/vehicleSnap/price.svg"
        },
        "mileage": {
            "value": "",
            "title": "Mileage",
            "required": false,
            "position": 13,
            "icon": "https://spyne-static.s3.amazonaws.com/console/inventoryDetails/vehicleInfo/vehicleSnap/mileage.svg"
        },
        "exteriorColor": {
            "value": [
                "Majestic White ",
                " Graphite Shadow ",
                " Warm Titanium ",
                " Grand Blue ",
                " MoonBow Blue ",
                " Deep Bordeaux ",
                " Mineral Black ",
                " Mocha Almond"
            ],
            "title": "Exterior Color",
            "required": false,
            "position": 6,
            "icon": "https://spyne-static.s3.amazonaws.com/console/inventoryDetails/vehicleInfo/vehicleSnap/exterior_color.svg"
        }
    }
}